/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import _ from "lodash";
import Modal from 'react-responsive-modal';
import { Map, InfoWindow, Marker, GoogleApiWrapper, Polygon, Polyline } from 'google-maps-react';

import axios from 'axios';
import { AgGridReact } from '@ag-grid-community/react';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import "@ag-grid-enterprise/all-modules/dist/styles/ag-grid.css";
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
import Select from 'react-select';
import * as XLSX from "xlsx";

import SweetAlert from 'react-bootstrap-sweetalert';
import DrawMap from '../common/drawmap';
import MyHeaderComponent from "./deviationheaderaction";
import Showtolls from "./showtolls";
import ShowChokePoints from "./showchokepoints";
import ShowTollsList from "./showtollslist";
import TollGrid from "./deviationtollgrid";
import ChokePointsGrid from "./deviationchokepoints";
import ApprovalDeviationRoute from "./approvaldeviationroute";
import DateDeviationRoute from "./datedeviationroute";
import ViewDeviationRouteData from "./viewdeviationroutedata";
import RouteGrid from "./deviationroutedata";
import $ from 'jquery';
import { getHyphenYYYYMMDD, getHyphenYYYYMMDDHHMMSS, getDDMMYYYYHHMMSS } from '../common/utils';

import { gMap } from '../../config/googleMaps';
import {
    getURLParams,
    updateURL
} from "../utils/urlManager.js";

var moment = require('moment');
var redirectURL = require('../redirectURL');
var googleAnalytics = require("../common/googleanalytics");

var aggriddata = [];
var originaldata;
var infoBox = require('../common/google-infowindow');

const map_plants = {
    "HM4N": "Neemrana", "HHHU": "Haridwar", "HHHD": "Dharuhera",
    "HHHG": "Gurgaon", "HM5V": "Halol", "HM6C": "Chittoor",
    "HE6C": "Chittoor-EV", "HP3N": "Neemrana"
};
const plant_coords = {
    "HM4N": { "lat": 27.968191, "lng": 76.37616 },
    "HHHU": { "lat": 29.95923, "lng": 78.06932 },
    "HHHD": { "lat": 28.232288, "lng": 76.801254 },
    "HHHG": { "lat": 28.434471, "lng": 77.01585 },
    "HM5V": { "lat": 22.572409, "lng": 73.46393 },
    "HM6C": { "lat": 13.533582, "lng": 79.955086 },
    "HE6C": { "lat": 13.533582, "lng": 79.955086 },
    "HP3N": { "lat": 27.96735, "lng": 76.37214 }
};

var map;
var waypoints = [];
var globalWayPointCount = 0;
var directionsDisplays = [];

const WAYPOINT_EXPORT_MODE = "single_column";

// Supported values:
// "single_column"
// "multiple_columns"


export default class SavedBaseRoutes extends Component {

    constructor(props) {
        super(props);
        this.displayData = [];
        this.searchBoxes = {};  // Cache for Google Places SearchBox instances per waypoint
        this.state = {
            loadshow: 'show-n',
            overly: 'show-n',
            modules: AllModules,
            alert: null,
            show: false,
            basicTitle: '',
            basicType: "default",
            dept_code: '',
            defaultColDef: {
                sortable: true,
                filter: true,
                autoHeight: true,
                resizable: true,
                width: 130
            },
            rowData: [],
            headerHeight: 60,
            rowHeight: 50,
            rowModelhighchartoptionsType: 'enterprise',
            rowGroupPanelShow: 'always',
            animateRows: true,
            debug: true,
            showToolPanel: false,
            griddata: [],
            routeRowData: {},
            rowSelection: "single",
            context: { componentParent: this },
            frameworkComponents: {
                MyHeaderComponent: MyHeaderComponent,
                Showtolls: Showtolls,
                ShowTollsList: ShowTollsList,
                ApprovalDeviationRoute: ApprovalDeviationRoute,
                DateDeviationRoute: DateDeviationRoute,
                ViewDeviationRouteData: ViewDeviationRouteData,
                ShowChokePoints: ShowChokePoints
            },
            loadingCellRenderer: "customLoadingCellRenderer",
            loadingCellRendererParams: { loadingMessage: "One moment please..." },
            rowModelType: "serverSide",
            paginationPageSize: 50,
            cacheBlockSize: 50,
            maxBlocksInCache: 2,
            pageTitle: "Summary",
            originaldata: "",
            orignalresponse: "",
            mapinfo: "",
            originoption: { "value": "ALL", "label": "ALL" },
            destinationoption: { "value": "ALL", "label": "ALL" },
            destinationarr: [],
            selectedorigin: '',
            selecteddestination: '',
            columnDefs: [],
            checkedinputs: [],
            uncheckedinputs: [],
            noofroutes: 3,
            tolls: [],
            tollshow: false,
            plantcoords: "",
            plantname: "",
            sliderTranslate: "",
            viewtolls: [],
            tollrowid: "",
            routeid: "",
            routeapprovestatus: "",
            open: false,
            route_reason: "",
            gridapi: [],
            viewroutedata: [],
            sliderRouteTranslate: "",
            sliderRouteTranslate1: "",
            sliderChokeTranslate: "",
            chokepoints: [],
            chokepointdata: [],
            originoptions: [],
            btn1: "btn-default",
            btn2: "btn-default",
            btn3: "btn-default",
            btn4: "btn-default",
            complete_analysis: [],
            base_routes_anlsysis: [],
            transporters_analysis: [],
            complete_trips: [],
            breaks_list: [],
            route_coords: [],
            gridHeight: "160px",
            "mapfor": "",
            destinationOptions: [],
            defaultTrips: [],
            selectedRoutes: [],
            dealersList: [],
            route_coords1: [],
            breaks_list1: [],
            tripsGridApi: {},
            defaultCompleteTrips: [],
            hideSummaryTab: false,
            lspusers_options: [],
            truck_types: [],
            period_types: [],
            selected_provider: { "label": "ALL", "value": "ALL" },
            selected_truck_type: { "label": "ALL", "value": "ALL" },
            selected_period_type: { "label": "ALL", "value": "ALL" },
            coords_to_plot: [],
            google_distance_via_waypoints: 0,
            expected_distance: 0,
            consigner_coordinates: {},
            savedBaseRoutes: [],
            selectedSource: "",
            selectedCity: "",
            alteredHeroSapRoute: {},
            heroSapRoute: "",
            waypointsmodal: false,
            selectedRow: {},
            addNewWayPoints: [],
            existing_route: false,
            changedWaypoints: [],
            defaultRowData: [],
            selectedDataTab: "OLD",
            showDataTabs: false,
            // New v2 waypoint modal state
            waypointsList: [],       // [{ id, value, order }] — the user's actual waypoints
            nextWaypointId: 1,
            draggedItem: null,
            draggedOverItem: null,
            // Stores the user-entered waypoint strings at submit time
            // so we can re-populate the modal correctly on subsequent opens
            userSubmittedWaypoints: [],
            // ── Bulk Upload (New Data tab only) ──
            bulkUploadModal: false,
            bulkFile: null,
            bulkFileName: "",
            bulkUploading: false,
            bulkSummary: null,
            bulkValidationModal: false,
        };
        this.onLoadFormRequest = this.onLoadFormRequest.bind(this);
    }

    /* ─── Alert helpers ─────────────────────────────────────── */

    closeAlert = () => {
        this.setState({ show: false });
    }

    hideAlert = () => {
        this.setState({ alert: null });
    }

    /* ─── Modal close ───────────────────────────────────────── */

    onCloseWaypointsModal() {
        this.searchBoxes = {};
        this.setState({
            waypointsmodal: false,
            waypointsList: [],
            draggedItem: null,
            draggedOverItem: null
        });
    }

    /* ─── Lifecycle ─────────────────────────────────────────── */

    componentDidMount() {
        window.addEventListener(
            "urlChange",
            this.handleURLChange
        );
        window.addEventListener(
            "popstate",
            this.handleURLChange
        );

        const currentPath =
            window.location.pathname
                .toLowerCase();

        const isSNDGRoute =
            currentPath.includes(
                "/herosaproutes"
            );

        const dept_code =
            isSNDGRoute
                ? "SNDG"
                : "LOG-PRT";
                
        this.setState({
            dept_code: dept_code,
            overly: "show-m",
            loadshow: "show-m"
        });
        var query = { dept_code: dept_code };

     

        redirectURL.post("/dashboard/getInitialDataForHeroSapRoutes", query).then((response) => {
            var plantdata = response.data.consigners || [];
            var originoptions = [{ "label": "ALL", "value": "ALL" }];
            plantdata = plantdata.filter(item => !!item && !!map_plants[item]);
            plantdata.map((item) => {
                originoptions.push({
                    value: item,
                    label: map_plants[item] || item
                });
            });
            var destinationOptions = [{ "label": "ALL", "value": "ALL" }];
            var destinationarr = (response.data.destinations || []).filter(city => city && city.trim());
            destinationarr.map((item) => {
                destinationOptions.push({ value: item, label: item });
            });
            this.setState({
                originoptions: originoptions,
                destinationOptions: destinationOptions,
                destinationarr
            });
        });

        const isPRTRoute = this.props.match.path === "/prtherosaproutes";
        const params =
            getURLParams();
        const initialTab =
            params&&params.tab === "NEW"
                ? "NEW"
                : "OLD";
        this.setState({
            dept_code,
            showDataTabs: !isPRTRoute,
            overly: "show-m",
            loadshow: "show-m"
        }, () => {
            if (isPRTRoute) {
                this.loadSavedBaseRoutes();
            } else {
                this.loadSavedBaseRoutes(initialTab);
            }
        });
    }

    componentWillUnmount() {

        window.removeEventListener(
            "urlChange",
            this.handleURLChange
        );

        window.removeEventListener(
            "popstate",
            this.handleURLChange
        );

    }
    /* ─── Load routes ───────────────────────────────────────── */
    handleURLChange = () => {

        const params =
            getURLParams();

        const tab =
            params&&params.tab || "OLD";

        if (
            this.state.showDataTabs &&
            tab !== this.state.selectedDataTab
        ) {

            this.loadSavedBaseRoutes(tab);

        }
    };

    loadSavedBaseRoutes = (dataType = "OLD") => {
        const query = { dept_code: this.state.dept_code };
        if (this.state.showDataTabs) {
            query.data_type = dataType;
        }
        this.setState({
            selectedDataTab: dataType,
            loadshow: "show-m",
            overly: "show-m"
        });
        redirectURL.post("/dashboard/getAllSavedBaseRoutes", query)
            .then((response) => {
                let rowData = response.data.savedBaseRoutes;
                this.setState({
                    selectedDataTab: dataType,
                    savedBaseRoutes: rowData,
                    rowData,
                    loadshow: "show-n",
                    overly: "show-n"
                });
                this.renderMap();
            })
            .catch(() => {
                this.setState({ loadshow: "show-n", overly: "show-n" });
            });
    }

    /* ─── Grid handlers ─────────────────────────────────────── */

    onGridReady = params => {
        this.gridApi = params.api;
        this.setState({ gridapi: params.api });
        this.gridColumnApi = params.columnApi;
        var sort = [{ colId: 'no_of_followers_percentage', sort: 'desc' }];
        this.gridApi.setSortModel(sort);
        this.gridApi.addEventListener('paginationChanged', (e) => { });
        this.gridApi.forEachLeafNode((node) => { });
    };

    onGridState = () => {
        this.colState = this.gridColumnApi.getColumnState();
        this.rowGroupState = this.gridColumnApi.getRowGroupColumns();
        this.pivotColumns = this.gridColumnApi.getPivotColumns();
        window.filterState = this.gridApi.getFilterModel();
        this.gridApi.setFilterModel(window.filterState);
    }

    /* ─── Select handlers ───────────────────────────────────── */

    changeOriginHandler = originoption => {
        this.setState({ originoption });
    }

    changeDestinationHandler = destinationoption => {
        this.setState({ destinationoption });
    }

    /* ─── Form submit (origin + destination filter) ─────────── */

    formHandler = (event) => {
        event.preventDefault();
        try {
            var tcheck = document.getElementById("tollcheck");
            if (tcheck.checked == true) { tcheck.checked = false; }
        } catch (e) { }

        this.setState({ loadshow: 'show-m', tolllist: [] });

        if (this.state.originoption.value != "" && this.state.destinationoption.value != "") {
            var formdata = {
                consigner_code: this.state.originoption.value,
                consignee_city: this.state.destinationoption.value,
            };
            this.setState({
                selectedSource: this.state.originoption.value,
                selectedCity: this.state.destinationoption.value
            });
            this.gridApi.forEachNode((node) => {
                if (node.data.consigner_code == this.state.originoption.value &&
                    node.data.consignee_city == this.state.destinationoption.value) {
                    node.setSelected(true);
                }
            });
            if (this.state.originoption.value == "ALL" || this.state.destinationoption.value == "ALL") {
                let filterData = this.state.savedBaseRoutes;
                const { originoption, destinationoption } = this.state;
                if (originoption.value !== "ALL" && destinationoption.value === "ALL") {
                    filterData = filterData.filter(item =>
                        item.consigner_code.toLowerCase() === originoption.value.toLowerCase()
                    );
                } else if (originoption.value === "ALL" && destinationoption.value !== "ALL") {
                    filterData = filterData.filter(item =>
                        item.consignee_city.toLowerCase() === destinationoption.value.toLowerCase()
                    );
                }
                if (filterData.length === 0) {
                    this.setState({
                        basicTitle: "No Hero SAP Route marked",
                        basicType: "warning",
                        show: true,
                        coords_to_plot: [],
                        consigner_coordinates: {},
                        heroSapRoute: [],
                        rowData: []
                    });
                    this.gridApi.deselectAll();
                } else {
                    this.setState({
                        rowData: filterData,
                        loadshow: "show-n",
                        overly: "show-n",
                        coords_to_plot: [],
                        consigner_coordinates: {},
                        heroSapRoute: []
                    });
                }
                this.renderMap();
            } else {
                this.onLoadFormRequest(formdata);
            }
        } else {
            this.setState({
                basicTitle: "Please select Consigner and Consignee City",
                basicType: "warning",
                show: true,
                overly: "show-n",
                loadshow: "show-n"
            });
        }
    }

    /* ─── Load route data for selected origin+destination ───── */

    onLoadFormRequest(formdata) {
        this.setState({ loadshow: "show-m", overly: "show-m" });

        var filteredData = this.state.savedBaseRoutes.filter(e =>
            e.consigner_code && (e.consigner_code.trim().toLowerCase() === formdata.consigner_code.trim().toLowerCase()) &&
            e.consignee_city && (e.consignee_city.trim().toLowerCase() === formdata.consignee_city.trim().toLowerCase())
        );

        if (filteredData.length == 0) {
            this.setState({
                basicTitle: "No Hero SAP Route marked",
                basicType: "warning",
                show: true,
                coords_to_plot: [],
                consigner_coordinates: {},
                heroSapRoute: [],
                rowData: []
            });
            this.gridApi.deselectAll();
            this.renderMap();
        } else {
            var payload = {
                "plant_code": this.state.originoption.value,
                "consigner_code": formdata.consigner_code,
                "consignee_city": formdata.consignee_city,
                "dept_code": this.state.dept_code
            };
            this.appendDataType(payload);

            redirectURL.post("dashboard/getConsignerCoordinates", payload).then((resp) => {
                var coords_to_plot = [];
                var alteredHeroSapRoute = {};

                if (resp.data.map_coords && resp.data.map_coords.length) {
                    const routeData = resp.data.map_coords[0];

                    if (routeData.route_coords) {
                        try {
                            coords_to_plot = eval(routeData.route_coords);
                        } catch (e) {
                            coords_to_plot = [];
                        }
                    }

                    if (routeData.alteredHeroSapRoute) {
                        try {
                            alteredHeroSapRoute = JSON.parse(decodeURI(routeData.alteredHeroSapRoute));
                        } catch (e) {
                            alteredHeroSapRoute = {};
                        }
                    }
                }

                this.setState({
                    coords_to_plot: coords_to_plot,
                    heroSapRoute: alteredHeroSapRoute,
                    google_distance_via_waypoints: filteredData[0]['google_distance_via_waypoints'],
                    expected_distance: filteredData[0]['expected_distance'],
                    consigner_coordinates: resp.data.consigner_coords,
                    selectedRow: filteredData[0],
                    rowData: filteredData
                });
                this.gridApi.selectAll();
                this.renderMap();
            });
        }
    }

    /* ─── Misc ──────────────────────────────────────────────── */

    onClickHideAll() {
        this.setState({
            loadshow: 'show-n',
            overly: 'show-n',
            sliderTranslate: '',
            sliderRouteTranslate: '',
            sliderChokeTranslate: ""
        });
    }

    changeHandler(event) {
        let name = event.target.name;
        let value = event.target.value;
        this.setState({ [name]: value });
    }

    /* ─── appendDataType helper ─────────────────────────────── */

    appendDataType = (payload = {}) => {
        if (this.state.showDataTabs && this.state.selectedDataTab) {
            payload.data_type = this.state.selectedDataTab;
        }
        return payload;
    }

    /* ─── Map ───────────────────────────────────────────────── */

    renderMap = () => {
        loadScript(`https://maps.googleapis.com/maps/api/js?key=${gMap.API_KEY}&libraries=places,drawing,geometry&callback=initMapWeather`);
        window.initMapWeather = this.initMap;
    }

    initMap = () => {
        this.setState({ overly: "show-m", loadshow: "show-m" });

        /*
         * ORIGINAL LOGIC PRESERVED:
         * heroSapRoutePresent = 1 when heroSapRoute is not empty string / undefined.
         * This drives whether we plot from raw coords OR from the saved altered route.
         *
         * Original condition was:
         *   if (this.state.heroSapRoute != undefined && this.state.heroSapRoute != "")
         *     heroSapRoutePresent = 1
         *
         * The v2 update INVERTED this accidentally. Restored below.
         */
        var heroSapRoutePresent = 0;
        if (this.state.heroSapRoute != undefined && this.state.heroSapRoute != "") {
            heroSapRoutePresent = 1;
        }

        var arr2 = this.state.coords_to_plot;
        waypoints = [];

        /*
         * ORIGINAL LOGIC:
         * Build sampling waypoints from coords_to_plot ONLY when
         * heroSapRoutePresent == 0 (i.e. no saved altered route exists yet).
         */
        if (arr2.length && heroSapRoutePresent == 0) {
            var freq = Math.round(arr2.length / 25);
            var start_index = freq;
            for (var i = 1; i < 26; i++) {
                try {
                    waypoints.push({
                        location: new window.google.maps.LatLng(arr2[start_index].lat, arr2[start_index].lng),
                        stopover: true,
                    });
                    start_index += freq;
                } catch (e) {
                    break;
                }
            }
        }

        try {
            var map_type = window.google.maps.MapTypeId.ROADMAP;
            map = new window.google.maps.Map(document.getElementById('map'), {
                center: new window.google.maps.LatLng(28.497236, 77.062363),
                mapTypeId: map_type,
                mapTypeControl: true,
                mapTypeControlOptions: {
                    style: window.google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
                    position: window.google.maps.ControlPosition.TOP_RIGHT
                },
                disableDefaultUI: true,
                fullscreenControl: true,
                zoomControl: true,
                panControl: false,
            });

            var bounds = new window.google.maps.LatLngBounds();
            bounds.extend(new window.google.maps.LatLng(23.63936, 68.14712));
            bounds.extend(new window.google.maps.LatLng(28.20453, 97.34466));

            /*
             * ORIGINAL LOGIC PRESERVED:
             * heroSapRoutePresent == 0 → plot from raw coords_to_plot
             * heroSapRoutePresent == 1 → use saved alteredHeroSapRoute.request.waypoints
             */
            if (arr2.length && heroSapRoutePresent == 0) {
                this.plotGoogleDirections(
                    new window.google.maps.LatLng(arr2[0].lat, arr2[0].lng),
                    new window.google.maps.LatLng(arr2[arr2.length - 1].lat, arr2[arr2.length - 1].lng)
                );
            } else {
                /*
                 * Safely access request.waypoints from the saved route.
                 * alteredHeroSapRoute is stored as the full Google Directions
                 * response object (JSON.stringify of directions.getDirections()).
                 */
                try {
                    waypoints = this.state.heroSapRoute.request.waypoints;
                } catch (e) {
                    waypoints = [];
                }
                let origin = plant_coords[this.state.selectedRow['consigner_code']];
                let source = new window.google.maps.LatLng(origin.lat, origin.lng);
                this.plotGoogleDirections(source, this.state.selectedRow['consignee_city']);
            }
        } catch (e) {
            console.log(e, "error in initMap");
        }

        try {
            // Plant marker
            let plantLat = this.state.consigner_coordinates.lat;
            let plantLng = this.state.consigner_coordinates.lng;

            let plantMarker = new window.google.maps.Marker({
                position: new window.google.maps.LatLng(plantLat, plantLng),
                icon: require('../../assets/icons/business.png'),
                map
            });
            var infowindow = new window.google.maps.InfoWindow();
            window.google.maps.event.addListener(plantMarker, 'mouseover', ((plantMarker) => {
                return () => {
                    var contentarr = [];
                    var header = "Plant";
                    contentarr.push({ "key": "Plant", "value": this.state.selectedSource });
                    var contentString = infoBox(plantMarker.icon, header, contentarr);
                    infowindow.setContent(contentString);
                    infowindow.open(map, plantMarker);
                };
            })(plantMarker));
            window.google.maps.event.addListener(plantMarker, 'mouseout', function () {
                infowindow.close();
            });

            let destinationPoint = null;

            if (
                arr2 &&
                arr2.length
            ) {

                destinationPoint =
                    arr2[arr2.length - 1];

            }
            else if (
                this.state.heroSapRoute &&
                this.state.heroSapRoute.routes &&
                this.state.heroSapRoute.routes.length
            ) {

                const route =
                    this.state.heroSapRoute.routes[0];

                const lastLeg =
                    route.legs[
                    route.legs.length - 1
                    ];

                destinationPoint = {
                    lat:
                        typeof lastLeg.end_location.lat === "function"
                            ? lastLeg.end_location.lat()
                            : lastLeg.end_location.lat,

                    lng:
                        typeof lastLeg.end_location.lng === "function"
                            ? lastLeg.end_location.lng()
                            : lastLeg.end_location.lng
                };
            }
            if (destinationPoint) {

                var marker = new window.google.maps.Marker({
                    position: new window.google.maps.LatLng(destinationPoint.lat, destinationPoint.lng),
                    icon: require('../../assets/icons/truck-end.png'),
                    map: map,
                });
                window.google.maps.event.addListener(marker, 'click', ((marker) => {
                    return () => {
                        var contentarr = [];
                        var header = "End Point";
                        contentarr.push({ "key": "Destination", "value": this.state.selectedCity });
                        var contentString = infoBox(marker.icon, header, contentarr, '');
                        infowindow.setContent(contentString);
                        infowindow.open(map, marker);
                    };
                })(marker));
            }
        } catch (e) {
            console.log("error in markers", e);
        }

        map.fitBounds(bounds);
        this.setState({ overly: "show-n", loadshow: "show-n" });
    }

    /* ─── Cell click (grid row actions) ────────────────────── */

    getWaypointLatLng(location) {

        let locationObj = location;

        if (
            locationObj &&
            locationObj.location
        ) {
            locationObj =
                locationObj.location;
        }

        const lat =
            locationObj &&
                typeof locationObj.lat === "function"
                ? locationObj.lat()
                : locationObj &&
                    locationObj.lat !== undefined
                    ? locationObj.lat
                    : null;

        const lng =
            locationObj &&
                typeof locationObj.lng === "function"
                ? locationObj.lng()
                : locationObj &&
                    locationObj.lng !== undefined
                    ? locationObj.lng
                    : null;

        return {
            lat,
            lng
        };
    }

    onCellClicked(cell) {
        if (cell.colDef.field == "_id") {
            // Plot route for selected row
            cell.node.setSelected(true);
            var formdata = {
                "plant_code": cell.data.consigner_code,
                "consigner_code": cell.data.consigner_code,
                "consignee_city": cell.data.consignee_city,
                "dept_code": this.state.dept_code,
            };
            if (this.state.showDataTabs) {
                formdata.data_type = cell.data.data_type;
            }
            redirectURL.post("dashboard/getConsignerCoordinates", formdata).then((resp) => {
                var heroSapRoute = {};
                var coords_to_plot = [];

                if (resp.data.map_coords && resp.data.map_coords.length) {
                    const routeData = resp.data.map_coords[0];

                    if (routeData.route_coords) {
                        try {
                            coords_to_plot = eval(routeData.route_coords);
                        } catch (e) {
                            coords_to_plot = [];
                        }
                    }
                    if (routeData.alteredHeroSapRoute) {
                        try {
                            heroSapRoute = JSON.parse(decodeURI(routeData.alteredHeroSapRoute));
                        } catch (e) {
                            heroSapRoute = {};
                        }
                    }
                }

                this.setState({
                    coords_to_plot: coords_to_plot,
                    heroSapRoute: heroSapRoute,
                    google_distance_via_waypoints: cell.data['google_distance_via_waypoints'],
                    expected_distance: cell.data['expected_distance'],
                    consigner_coordinates: resp.data.consigner_coords,
                    selectedSource: map_plants[cell.data.consigner_code],
                    selectedCity: cell.data.consignee_city,
                    selectedRow: cell.data,
                    existing_route: true,
                    // Clear submitted waypoints so modal starts clean for this row
                    userSubmittedWaypoints: []
                }, () => {
                    this.renderMap();
                });
            });
        } else if (cell.colDef.field == "add_way_points") {
            /*
             * WAYPOINTS MODAL OPEN for existing row.
             *
             * FIX: The 26-waypoint bug happened because:
             *   1. heroSapRoute.request.waypoints after Google processing
             *      contains ALL optimized intermediate points (up to 25).
             *   2. Google's LatLng objects have lat()/lng() as FUNCTIONS
             *      not plain number properties, so coordinate extraction failed.
             *
             * SOLUTION:
             *   Priority 1: Use userSubmittedWaypoints (strings the user typed)
             *               stored when they last submitted the modal.
             *   Priority 2: Extract from heroSapRoute.request.waypoints
             *               but ONLY stopover:true entries, and safely call
             *               lat()/lng() as functions.
             *   Priority 3: Open empty modal so user can add waypoints fresh.
             */

            let existingWaypoints = [];

            if (
                cell.data.waypoints &&
                Array.isArray(cell.data.waypoints) &&
                cell.data.waypoints.length
            ) {
                existingWaypoints =
                    cell.data.waypoints.map(
                        (wp, index) => ({

                            id: index + 1,

                            value:
                                wp.location ||
                                wp.value ||
                                wp.waypoint ||
                                "",

                            originalLocation:
                                wp.lat !== null &&
                                    wp.lat !== undefined &&
                                    wp.lng !== null &&
                                    wp.lng !== undefined
                                    ? {
                                        lat: wp.lat,
                                        lng: wp.lng
                                    }
                                    : null,

                            order:
                                wp.order !== undefined
                                    ? wp.order
                                    : index
                        })
                    );

            }
            else if (
                this.state.heroSapRoute &&
                this.state.heroSapRoute.request &&
                Array.isArray(
                    this.state.heroSapRoute.request.waypoints
                )
            ) {

                existingWaypoints =
                    this.state.heroSapRoute.request.waypoints
                        .filter(
                            wp =>
                                wp.location &&
                                wp.stopover === true
                        )
                        .map((wp, index) => {

                            let value = "";
                            let originalLocation = null;

                            if (typeof wp.location === "string") {

                                value = wp.location;

                            }
                            else if (
                                wp.location &&
                                wp.location.query
                            ) {

                                value = wp.location.query;

                            }
                            else if (
                                wp.location &&
                                wp.location.formatted_address
                            ) {

                                value = wp.location.formatted_address;

                            }
                            else {

                                const coords =
                                    this.getWaypointLatLng(
                                        wp.location
                                    );

                                if (
                                    coords.lat !== null &&
                                    coords.lng !== null
                                ) {

                                    value =
                                        Number(coords.lat).toFixed(6) +
                                        ", " +
                                        Number(coords.lng).toFixed(6);

                                    originalLocation = {
                                        lat: coords.lat,
                                        lng: coords.lng
                                    };
                                }
                            }

                            return {
                                id: index + 1,
                                value: value,
                                originalLocation: originalLocation,
                                order: index
                            };
                        });
            }

            this.setState({
                waypointsmodal: true,
                selectedRow: cell.data,
                existing_route: true,
                waypointsList: existingWaypoints,
                nextWaypointId:
                    existingWaypoints.length + 1
            });
        }
    }

    onRowSelected(cell) {
        this.setState({ existing_route: true });
    }

    /* ─── Save route (ORIGINAL LOGIC — unchanged) ───────────── */

    onClickSaveRoute() {
        let selectedNodes = this.gridApi.getSelectedNodes();
        if (selectedNodes.length || this.state.existing_route == false) {
            let selectedData = selectedNodes.map(node => node.data);
            var alteredHeroSapRoute = this.state.alteredHeroSapRoute;
           const hasWaypoints =
                this.state.waypointsList.some(
                    wp => wp.value && wp.value.trim()
                );

            if (
                Object.keys(alteredHeroSapRoute).length ||
                hasWaypoints
            ) {
                if (this.state.existing_route) {
                    var formdata = {
                        "row_id": selectedData[0]['_id'],
                        alteredHeroSapRoute: encodeURI(JSON.stringify(alteredHeroSapRoute)),
                        existing_route: this.state.existing_route
                    };
                } else {
                    var expected_distance = 0;
                    alteredHeroSapRoute.routes[0].legs.map((e) => {
                        expected_distance = expected_distance + e.distance.value;
                    });
                    expected_distance = Math.round(expected_distance / 1000);
                    var formdata = {
                        consigner_code: this.state.originoption.value,
                        consignee_city: this.state.destination_new,
                        alteredHeroSapRoute: encodeURI(JSON.stringify(alteredHeroSapRoute)),
                        existing_route: this.state.existing_route,
                        created_by: localStorage.getItem("email"),
                        expected_distance: expected_distance,
                        google_distance_via_waypoints: expected_distance
                    };
                }
                if (!["", undefined, null, "undefined"].includes(this.state.dept_code)) {
                    formdata.dept_code = this.state.dept_code;
                }
                this.appendDataType(formdata);
                this.setState({ loadshow: "show-m", overly: "show-m" });
                formdata.waypoints =
                    this.state.waypointsList
                        .filter(
                            e =>
                                e.value &&
                                e.value.trim()
                        )
                        .map(
                            (e, index) => ({
                                order: index + 1,
                                location: e.value.trim(),
                                lat:
                                    e.originalLocation
                                        ? (
                                            typeof e.originalLocation.lat === "function"
                                                ? e.originalLocation.lat()
                                                : e.originalLocation.lat
                                        )
                                        : null,

                                lng:
                                    e.originalLocation
                                        ? (
                                            typeof e.originalLocation.lng === "function"
                                                ? e.originalLocation.lng()
                                                : e.originalLocation.lng
                                        )
                                        : null
                            })
                        );
                formdata.user_email =
                    localStorage.getItem("email");

                formdata.user_name  =
                    localStorage.getItem("username");
                redirectURL.post("/dashboard/saveAlteredHeroSapRoute", formdata).then((response) => {
                    if (response.data.message == "success") {
                        this.loadSavedBaseRoutes(
                            this.state.selectedDataTab
                        );
                        this.setState({ basicTitle: "Saved Successfully", basicType: "success", show: true });
                    } else {
                        this.setState({ basicTitle: "Unable to store data", basicType: "warning", show: true });
                    }
                    this.setState({ loadshow: "show-n", overly: "show-n" });
                });
            } else {
                this.setState({ basicTitle: "Route unchanged", basicType: "warning", show: true });
            }
        } else {
            this.setState({ basicTitle: "Select atleast one route", basicType: "warning", show: true });
        }
    }

    /* ─── Plot directions (ORIGINAL LOGIC — unchanged) ─────── */

    plotGoogleDirections(start, end) {
        directionsDisplays.map((e) => { e.setMap(null); });
        var directionsService = new window.google.maps.DirectionsService();
        var method = 'DRIVING';
        var request = {
            origin: start,
            destination: end,
            travelMode: window.google.maps.DirectionsTravelMode[method],
            provideRouteAlternatives: false,
            waypoints: waypoints,
            optimizeWaypoints: false,
        };
        directionsService.route(request, (response, status) => {
            if (status == window.google.maps.DirectionsStatus.OK) {
                var routes = response.routes;
                var colors = ['#157254'];
                directionsDisplays = [];
                for (var i = 0; i < routes.length; i++) {
                    var directionsDisplay = new window.google.maps.DirectionsRenderer({
                        map: map,
                        directions: response,
                        routeIndex: i,
                        draggable: true,
                        polylineOptions: {
                            strokeColor: colors[i],
                            strokeWeight: 4,
                            strokeOpacity: 1
                        }
                    });
                    var directions = directionsDisplay.getDirections();
                    var changedWaypoints = this.state.changedWaypoints;
                    changedWaypoints.push(directions);
                    this.setState({ changedWaypoints: changedWaypoints });
                    // After submitting new waypoints, store the directions for saving
                    if (this.state.addNewWayPoints.length) {
                        this.setState({ alteredHeroSapRoute: directions });
                    }
                    directionsDisplays.push(directionsDisplay);
                    window.google.maps.event.addListener(directionsDisplay, 'directions_changed', ((directionsDisplay, i) => {
                        return () => {
                            var directions = directionsDisplay.getDirections();
                            var changedWaypoints = this.state.changedWaypoints;
                            changedWaypoints.push(directions);
                            this.setState({
                                alteredHeroSapRoute: directions,
                                changedWaypoints: changedWaypoints
                            });
                        };
                    })(directionsDisplay, i));
                }
            }
        });
    }

    /* ─── Open modal for NEW waypoint (no existing row) ─────── */

    onClickAddWaypoints() {
        this.setState({
            waypointsmodal: true,
            selectedRow: {},
            existing_route: false,
            waypointsList: [],
            nextWaypointId: 1,
            userSubmittedWaypoints: []
        });
    }

    /* ─── Bulk Upload (New Data tab only) ───────────────────── */

    onClickBulkUpload() {
        this.setState({
            bulkUploadModal: true,
            bulkFile: null,
            bulkFileName: "",
            bulkSummary: null
        });
    }

    onCloseBulkUploadModal() {
        this.setState({ bulkUploadModal: false });
    }

    onCloseBulkValidationModal() {
        this.setState({ bulkValidationModal: false });
    }

    onBulkFileChange = (e) => {
        var file = e.target.files && e.target.files[0];
        if (!file) {
            this.setState({ bulkFile: null, bulkFileName: "" });
            return;
        }
        var name = (file.name || "").toLowerCase();
        var allowed = [".xlsx", ".xls", ".csv"];
        var ok = allowed.some(function (ext) { return name.endsWith(ext); });
        if (!ok) {
            this.setState({
                bulkFile: null,
                bulkFileName: "",
                basicTitle: "Unsupported file. Please upload .xlsx, .xls or .csv",
                basicType: "warning",
                show: true
            });
            // reset the input so the same bad file can be re-picked after correction
            e.target.value = "";
            return;
        }
        this.setState({ bulkFile: file, bulkFileName: file.name });
    }

    onSubmitBulkUpload = () => {
        if (!this.state.bulkFile) {
            this.setState({ basicTitle: "Please choose a file first", basicType: "warning", show: true });
            return;
        }
        // Guard: bulk upload is only valid on the New Data tab.
        if (!(this.state.showDataTabs && this.state.selectedDataTab === "NEW")) {
            this.setState({ basicTitle: "Bulk Upload is available only under New Data", basicType: "warning", show: true });
            return;
        }

        var formData = new FormData();
        formData.append("file", this.state.bulkFile);
        // dept_code / data_type from UI context — not hardcoded.
        if (!["", undefined, null, "undefined"].includes(this.state.dept_code)) {
            formData.append("dept_code", this.state.dept_code);
        }
        formData.append("data_type", this.state.selectedDataTab);
        formData.append("user_email", localStorage.getItem("email") || "");
        formData.append("user_name", localStorage.getItem("username") || "");

        this.setState({ bulkUploading: true, loadshow: "show-m", overly: "show-m" });

        // NOTE: do not set Content-Type manually — the browser/axios must add the
        // multipart boundary itself, otherwise the server cannot parse the file.
        redirectURL.post("/dashboard/bulkUploadHeroSapRoutes", formData).then((response) => {
            var data = response.data || {};
            this.setState({ bulkUploading: false, loadshow: "show-n", overly: "show-n" });

            // File/header-level failure (no summary) → show the message.
            if (data.status && data.status !== 200 && data.totalRows === undefined) {
                this.setState({
                    bulkUploadModal: false,
                    basicTitle: data.message || "Bulk upload failed",
                    basicType: "danger",
                    show: true
                });
                return;
            }

            // Row-level summary → show the validation summary modal and refresh the grid.
            this.setState({
                bulkUploadModal: false,
                bulkSummary: data,
                bulkValidationModal: true
            });
            this.loadSavedBaseRoutes(this.state.selectedDataTab);
        }).catch((err) => {
            var msg = "Bulk upload failed";
            if (err && err.response && err.response.data && err.response.data.message) {
                msg = err.response.data.message;
            }
            this.setState({
                bulkUploading: false,
                loadshow: "show-n",
                overly: "show-n",
                bulkUploadModal: false,
                basicTitle: msg,
                basicType: "danger",
                show: true
            });
        });
    }

    downloadBulkErrorReport = () => {
        var summary = this.state.bulkSummary;
        if (!summary || !summary.errors || !summary.errors.length) return;
        var rows = summary.errors.map(function (e) {
            return { Row: e.row, Column: e.column, Value: e.value, Reason: e.message };
        });
        var ws = XLSX.utils.json_to_sheet(rows);
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Errors");
        XLSX.writeFile(wb, "bulk_upload_errors.xlsx");
    }

    /* ─── Destination search box (original logic) ───────────── */

    onDestinationSearch = () => {
        var input = document.getElementById('way_point_destination_search');
        var searchBox = new window.google.maps.places.SearchBox(input);
        searchBox.addListener('places_changed', function () {
            var places = searchBox.getPlaces();
            if (places.length == 0) { return; }
            var bounds = new window.google.maps.LatLngBounds();
            places.forEach(function (place) {
                if (!place.geometry) { return; }
                if (place.geometry.viewport) {
                    bounds.union(place.geometry.viewport);
                } else {
                    bounds.extend(place.geometry.location);
                }
            });
        });
    }

    /* ─── Data tab switch ───────────────────────────────────── */

    changeDataTab = (tabType) => {

        if (this.state.selectedDataTab === tabType) {
            return;
        }

        updateURL({
            tab: tabType
        });

        this.setState({
            coords_to_plot: [],
            heroSapRoute: [],
            selectedRow: {},
            consigner_coordinates: {}
        });

        if (this.gridApi) {
            this.gridApi.deselectAll();
        }

        this.loadSavedBaseRoutes(tabType);
    }

    /* ─── Drag and drop handlers ────────────────────────────── */

    handleDragStart = (e, item) => {
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/plain', item.id);
        this.setState({ draggedItem: item });
    };

    handleDragOver = (e, item) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
        if (this.state.draggedOverItem && this.state.draggedOverItem.id !== item.id) {
            this.setState({ draggedOverItem: item });
        }
    };

    handleDragEnd = () => {
        this.setState({ draggedItem: null, draggedOverItem: null });
    };

    handleDrop = (e, targetItem) => {
        e.preventDefault();
        const { draggedItem, waypointsList } = this.state;
        if (!draggedItem) return;
        const draggedId = draggedItem.id;
        const targetId = targetItem.id;
        if (draggedId === targetId) return;
        const newList = [...waypointsList];
        const draggedIndex = newList.findIndex(item => item.id === draggedId);
        const targetIndex = newList.findIndex(item => item.id === targetId);
        const [removed] = newList.splice(draggedIndex, 1);
        newList.splice(targetIndex, 0, removed);
        const updatedList = newList.map((item, idx) => ({ ...item, order: idx }));
        this.setState({ waypointsList: updatedList, draggedItem: null, draggedOverItem: null });
    };

    /* ─── Waypoint CRUD ─────────────────────────────────────── */

    onClickAddNewWayPointModal = () => {
        const { waypointsList, nextWaypointId } = this.state;
        if (waypointsList.length >= 25) {
            this.setState({ basicTitle: "Only 25 Way Points are allowed", basicType: "warning", show: true });
            return;
        }
        const newWaypoint = { id: nextWaypointId, value: '', order: waypointsList.length };
        this.setState({
            waypointsList: [...waypointsList, newWaypoint],
            nextWaypointId: nextWaypointId + 1
        });
    };

    updateWaypointValue = (id, value) => {
        const updatedList = this.state.waypointsList.map(item =>
            item.id === id
                ? {
                    ...item,
                    value,
                    originalLocation: null
                } : item
        );
        this.setState({ waypointsList: updatedList });
    };

    onClickRemoveWayPointModal = (id) => {
        let filteredList = this.state.waypointsList.filter(item => item.id !== id);
        filteredList = filteredList.map((item, idx) => ({ ...item, order: idx }));
        this.setState({ waypointsList: filteredList });
    };

    /* ─── Google Places SearchBox per waypoint input ─────────
     * Cache searchBox instances so we don't create duplicates
     * on re-focus (original pattern preserved).
     */
    onFocusSearchModal = (e, waypointId) => {
        const input = e.target;
        if (this.searchBoxes[waypointId]) { return; }
        const searchBox = new window.google.maps.places.SearchBox(input);
        this.searchBoxes[waypointId] = searchBox;
        searchBox.addListener("places_changed", () => {
            const places = searchBox.getPlaces();
            if (!places || !places.length) { return; }
            const place = places[0];
            const lat =
                place.geometry.location.lat();

            const lng =
                place.geometry.location.lng();

            const updatedList =
                this.state.waypointsList.map(item =>
                    item.id === waypointId
                        ? {
                            ...item,
                            value:
                                place.formatted_address ||
                                place.name ||
                                "",

                            originalLocation: {
                                lat,
                                lng
                            }
                        }
                        : item
                );

            this.setState({
                waypointsList: updatedList
            });
        });
    };

    /* ─── Submit waypoints (new v2 handler) ─────────────────── */

    onSubmitWayPointsUpdated = (e) => {
        e.preventDefault();
        const { waypointsList, existing_route, selectedRow } = this.state;

        // Only keep waypoints with non-empty string values
        const validWaypoints = waypointsList.filter(
            wp => typeof wp.value === "string" && wp.value.trim() !== ""
        );

        if (validWaypoints.length === 0) {
            this.setState({ basicTitle: "Please add at least one waypoint", basicType: "warning", show: true });
            return;
        }

        // Build Google Directions API waypoint format
        const googleWaypoints = validWaypoints.map(wp => {

            if (wp.originalLocation) {

                const coords =
                    this.getWaypointLatLng(
                        wp.originalLocation
                    );

                if (
                    coords.lat !== null &&
                    coords.lng !== null
                ) {

                    return {
                        location: {
                            lat: coords.lat,
                            lng: coords.lng
                        },
                        stopover: true
                    };
                }
            }

            return {
                location: wp.value.trim(),
                stopover: true
            };

        });

        // Update the module-level waypoints array (original pattern)
        waypoints = googleWaypoints;

        // Store user's actual string waypoints for modal re-population
        const userSubmittedWaypoints = validWaypoints.map(wp => wp.value.trim());

        // Keep addNewWayPoints for backward compatibility with onClickSaveRoute check
        const addNewWayPoints = validWaypoints.map(wp => wp.id);

        this.setState({
            waypointsmodal: false,
            addNewWayPoints: addNewWayPoints,
            userSubmittedWaypoints: userSubmittedWaypoints
        });

        let destination_new = existing_route
            ? selectedRow.consignee_city
            : ($('#way_point_destination_search').val() || "");

        if (!existing_route) {
            this.setState({ destination_new });
        }

        if (existing_route) {
            // Existing route: use plant_coords for origin
            const origin = plant_coords[selectedRow.consigner_code];
            if (!origin) {
                this.setState({ basicTitle: "Plant coordinates not found", basicType: "warning", show: true });
                return;
            }
            const source = new window.google.maps.LatLng(origin.lat, origin.lng);
            this.plotGoogleDirections(source, selectedRow.consignee_city);
        } else {
            // New route: fetch consigner coords first (original flow)
            let source = this.state.originoption.label;
            let destination = this.state.destinationoption.value;

            let payloadGC = {
                plant_code: this.state.originoption.value,
                map_coords: false,
                destination,
                consigner_code: this.state.originoption.value,
                consignee_city: this.state.destinationoption.value,
                dept_code: this.state.dept_code
            };
            this.appendDataType(payloadGC);

            if (source && destination) {
                redirectURL.post("dashboard/getConsignerCoordinates", payloadGC).then((resp) => {
                    const srcLatLng = new window.google.maps.LatLng(
                        resp.data.consigner_coords.lat,
                        resp.data.consigner_coords.lng
                    );
                    this.gridApi.deselectAll();
                    this.plotGoogleDirections(srcLatLng, destination_new);
                });
            } else {
                this.gridApi.deselectAll();
                this.setState({ basicTitle: "Source & Destination should be selected", basicType: "warning", show: true });
            }
        }
    };

    // downloadRoutesExcel() {

    //     const exportData =
    //         buildExportData(
    //             this.state.rowData,
    //             WAYPOINT_EXPORT_MODE
    //         );

    //     this.gridApi.exportDataAsExcel({

    //         fileName:
    //             "Hero_SAP_Routes.xlsx",

    //         sheetName:
    //             "Routes",

    //         processCellCallback:
    //             params => {

    //                 return params.value;
    //             },

    //         customHeader: [],

    //         rowData:
    //             exportData
    //     });
    // }
    downloadRoutesExcel() {

        const exportData =
            buildExportData(
                this.state.rowData,
                WAYPOINT_EXPORT_MODE
            );

        const worksheet =
            XLSX.utils.json_to_sheet(
                exportData
            );

        const workbook =
            XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            "Hero SAP Routes"
        );

        XLSX.writeFile(
            workbook,
            "Hero_SAP_Routes.xlsx"
        );
    }

    /* ─── Render ─────────────────────────────────────────────── */

    render() {
        const dStyles = { width: '100%', height: '600px' };
        const columnDefs = [
            { headerName: "", field: "checkbox", width: 50, checkboxSelection: true },
            {
                headerName: "", field: "add_way_points",
                cellRenderer: (params) => '<i class="fa fa-map-marker f25"></i>',
                width: 50
            },
            {
                headerName: "", field: "_id",
                cellRenderer: (params) => '<i class="icofont icofont-map-pins f25"></i>',
                width: 60
            },
            {
                headerName: "Source", field: "consigner_code", width: 120,
                valueGetter: (params) => map_plants[params.data.consigner_code]
            },
            { headerName: "Destination", field: "consignee_city", width: 120 },
            { headerName: "Hero SAP Distance (Km)", field: "expected_distance", width: 120 },
            {
                headerName: "Google Distance (Km)",
                field: "google_distance_via_waypoints",
                width: 140
            },
            {
                headerName: "Waypoints",
                field: "waypoints",
                width: 350,
                autoHeight: true,
                wrapText: true,
                valueGetter: (params) => {

                    if (
                        !params.data.waypoints ||
                        !params.data.waypoints.length
                    ) {
                        return "";
                    }

                    return params.data.waypoints
                        .sort((a, b) => a.order - b.order)
                        .map(wp => wp.location)
                        .join(" → ");
                }
            }
        ];

        return (
            <div className="container-fluid">
                <SweetAlert
                    show={this.state.show}
                    type={this.state.basicType}
                    title={this.state.basicTitle}
                    onConfirm={this.closeAlert}
                />
                {this.state.alert}

                {/* Data tabs (SNDG only) */}
                <div className="row align-items-end mb-4">

                    {/* Tabs */}
                    {this.state.showDataTabs && (
                        <div className="col-auto">
                            <div className="route-tabs mb-0">
                                <button
                                    className={`route-tab ${this.state.selectedDataTab === "OLD" ? "active" : ""}`}
                                    onClick={() => this.changeDataTab("OLD")}
                                >
                                    Old Data
                                </button>

                                <button
                                    className={`route-tab ${this.state.selectedDataTab === "NEW" ? "active" : ""}`}
                                    onClick={() => this.changeDataTab("NEW")}
                                >
                                    New Data
                                </button>
                            </div>
                        </div>
                    )}

                    {/* Origin */}
                    <div className="col-xl-2 col-lg-2">
                        <label>Origin</label>
                        <Select
                            name="originoption"
                            value={this.state.originoption}
                            onChange={this.changeOriginHandler.bind(this)}
                            options={this.state.originoptions}
                        />
                    </div>

                    {/* Destination */}
                    <div className="col-xl-2 col-lg-2">
                        <label>Destination</label>
                        <Select
                            name="destinationoption"
                            value={this.state.destinationoption}
                            onChange={this.changeDestinationHandler.bind(this)}
                            options={this.state.destinationOptions}
                        />
                    </div>

                    {/* Submit */}
                    <div className="col-xl-2 col-lg-2">
                        <button
                            type="button"
                            className="btn btn-success bd-r-8"
                            onClick={this.formHandler.bind(this)}
                        >
                            Submit
                        </button>
                    </div>

                </div>

                <div className="row">
                    <div className="col-xl-12 col-lg-12">
                        {/* Filter row */}
                       

                        <div className="card">
                            <div className="card-header">
                                <h5 style={{ float: "left", width: "50%" }}>
                                    <i className="icofont icofont-map-pins f25"></i> <span>Hero SAP Routes</span>
                                </h5>
                            </div>
                            <div className="card-body row pr-2">
                                {/* Action bar */}
                                <div className="row col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                    <div className="col-xl-4 col-lg-4 pr-0 mr-0 d-flex justify-content-between">
                                        <button
                                            className="btn btn-success bd-r-8 herosap-btn"
                                            onClick={this.onClickAddWaypoints.bind(this)}
                                        >
                                            <i className="fa fa-map-marker ml-1 mr-2"></i> 
                                            Add Waypoints
                                        </button>
                                        <button
                                            className="btn btn-primary bd-r-8 ml-2 mr-3 herosap-btn"
                                            onClick={this.downloadRoutesExcel.bind(this)}
                                        >
                                            <i className="fa fa-download ml-1 mr-2"></i>
                                            Download
                                        </button>
                                        {/* Bulk Upload — New Data tab only. Does not affect Old Data,
                                            PRT, Add/Edit/Delete, Search, Filters, or plotting. */}
                                        {this.state.showDataTabs && this.state.selectedDataTab === "NEW" &&false && (
                                            <button
                                                className="btn btn-info bd-r-8 ml-2 mr-3 herosap-btn"
                                                onClick={this.onClickBulkUpload.bind(this)}
                                            >
                                                <i className="fa fa-upload ml-1 mr-2"></i>
                                                Bulk Upload
                                            </button>
                                        )}
                                    </div>
                                    <div className="col-xl-8 col-lg-8 pl-0 pr-0">
                                        <div className="route-actions-container">
                                            <button
                                                className="btn btn-warning bd-r-8 herosap-btn"
                                                onClick={this.onClickSaveRoute.bind(this)}
                                            >
                                                <i className="fa fa-save ml-1 mr-2"></i> 
                                                Save Route
                                            </button>
                                            <div className="route-legend">
                                                <div className="legend-item">
                                                    <span className="legend-line" style={{ background: "#452a68" }} />
                                                    <span className="legend-text">Missed GPS Route</span>
                                                </div>
                                                <div className="legend-item">
                                                    <span className="legend-line" style={{ background: "#157254" }} />
                                                    <span className="legend-text">Hero SAP Route</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Grid + Map */}
                                <div className="row col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                    <div className="col-xl-4 col-lg-4">
                                        <div id="myGrid" style={{ height: "600px", width: "100%" }} className="ag-theme-balham">
                                            <AgGridReact
                                                modules={this.state.modules}
                                                columnDefs={columnDefs}
                                                defaultColDef={this.state.defaultColDef}
                                                rowData={this.state.rowData}
                                                enableCharts={false}
                                                enableRangeSelection={true}
                                                autoGroupColumnDef={this.state.autoGroupColumnDef}
                                                frameworkComponents={this.state.frameworkComponents}
                                                onGridReady={this.onGridReady}
                                                onGridState={this.onGridState}
                                                statusBar={this.state.statusBar}
                                                pagination={true}
                                                onCellClicked={this.onCellClicked.bind(this)}
                                                onRowSelected={this.onRowSelected.bind(this)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-xl-8 col-lg-8" id="map" style={dStyles}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Loader */}
                <div className={"dataLoadpage " + (this.state.loadshow)}></div>
                <div className={"dataLoadpageimg " + (this.state.loadshow)}>
                    <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
                </div>
                <div className={"overlay-part " + (this.state.overly)} onClick={this.onClickHideAll.bind(this)}></div>

                {/* ── Waypoints Modal ──────────────────────────────── */}
                <Modal
                    open={this.state.waypointsmodal}
                    onClose={this.onCloseWaypointsModal.bind(this)}
                    classNames={{
                        modal: "waypoints-modal-custom",
                        overlay: "waypoints-modal-overlay",
                        closeButton: "waypoints-close-button",
                        closeIcon: "waypoints-close-icon"
                    }}
                    closeOnEsc={true}
                    closeOnOverlayClick={true}
                    showCloseButton={true}
                >
                    <div className="waypoints-modal-container">
                        {/* Header */}
                        <div className="waypoints-modal-header">
                            <div className="waypoints-modal-title">
                                <div className="waypoints-title-icon">
                                    <i className="fa fa-map-marker"></i>
                                </div>
                                <div>
                                    <h3>Manage Route Waypoints</h3>
                                    <p>Add, remove and reorder route waypoints</p>
                                </div>
                            </div>
                        </div>

                        {/* Form */}
                        <form className="waypoints-modal-body" onSubmit={this.onSubmitWayPointsUpdated.bind(this)}>

                            {/* Source */}
                            <div className="waypoints-section source-section">
                                <div className="section-label">
                                    <span className="section-icon">📍</span>
                                    <span>Source</span>
                                </div>
                                {this.state.existing_route ? (
                                    <div className="static-location">
                                        <i className="fa fa-building"></i>
                                        <span>{map_plants[this.state.selectedRow.consigner_code]}</span>
                                    </div>
                                ) : (
                                    <Select
                                        name="originoption"
                                        closeMenuOnSelect={true}
                                        value={this.state.originoption}
                                        className="waypoints-select"
                                        onChange={this.changeOriginHandler.bind(this)}
                                        options={this.state.originoptions}
                                        placeholder="Select source location..."
                                        required
                                    />
                                )}
                            </div>

                            {/* Waypoints list */}
                            <div className="waypoints-section waypoints-list-section">
                                <div className="section-label">
                                    <span className="section-icon">🛑</span>
                                    <span>Waypoints</span>
                                    <span className="waypoint-counter">{this.state.waypointsList.length}/25</span>
                                </div>

                                <div className="waypoints-list">
                                    {this.state.waypointsList.length === 0 ? (
                                        <div className="empty-waypoints">
                                            <i className="fa fa-map-marker"></i>
                                            <p>No waypoints added yet</p>
                                            <span>Click "Add New Waypoint" to start building your route</span>
                                        </div>
                                    ) : (
                                        this.state.waypointsList.map((wp, idx) => (
                                            <div
                                                key={wp.id}
                                                className={[
                                                    "waypoint-card",
                                                    this.state.draggedItem && this.state.draggedItem.id === wp.id ? "dragging" : "",
                                                    this.state.draggedOverItem && this.state.draggedOverItem.id === wp.id ? "drag-over" : ""
                                                ].filter(Boolean).join(" ")}
                                                draggable={true}
                                                onDragStart={(e) => this.handleDragStart(e, wp)}
                                                onDragOver={(e) => this.handleDragOver(e, wp)}
                                                onDrop={(e) => this.handleDrop(e, wp)}
                                                onDragEnd={this.handleDragEnd.bind(this)}
                                            >
                                                <div className="waypoint-drag-handle" title="Drag to reorder">
                                                    <i className="fa fa-bars"></i>
                                                </div>
                                                <div className="waypoint-number-badge">{idx + 1}</div>
                                                <div className="waypoint-content">
                                                    <input
                                                        type="text"
                                                        className="waypoint-address-input"
                                                        value={wp.value}
                                                        onChange={(e) => this.updateWaypointValue(wp.id, e.target.value)}
                                                        onFocus={(e) => this.onFocusSearchModal(e, wp.id)}
                                                        placeholder="Enter address or search location"
                                                        autoComplete="off"
                                                    />
                                                </div>
                                                <button
                                                    type="button"
                                                    className="waypoint-delete-btn"
                                                    onClick={() => this.onClickRemoveWayPointModal(wp.id)}
                                                    title="Remove waypoint"
                                                >
                                                    <i className="fa fa-trash"></i>
                                                </button>
                                            </div>
                                        ))
                                    )}
                                </div>

                                <button
                                    type="button"
                                    className="add-waypoint-btn-new"
                                    onClick={this.onClickAddNewWayPointModal.bind(this)}
                                    disabled={this.state.waypointsList.length >= 25}
                                >
                                    <i className="fa fa-plus-circle"></i>
                                    Add New Waypoint
                                </button>
                            </div>

                            {/* Destination */}
                            <div className="waypoints-section destination-section">
                                <div className="section-label">
                                    <span className="section-icon">🏁</span>
                                    <span>Destination</span>
                                </div>
                                {this.state.existing_route ? (
                                    <div className="static-location">
                                        <i className="fa fa-flag"></i>
                                        <span>{this.state.selectedRow.consignee_city}</span>
                                    </div>
                                ) : (
                                    <div className="destination-input-wrapper">
                                        <i className="fa fa-search location-search-icon"></i>
                                        <input
                                            type="text"
                                            className="destination-input"
                                            onChange={this.onDestinationSearch}
                                            id="way_point_destination_search"
                                            placeholder="Enter destination address..."
                                            autoComplete="off"
                                            required
                                        />
                                    </div>
                                )}
                            </div>

                            {/* Footer */}
                            <div className="waypoints-modal-footer">
                                <button
                                    type="button"
                                    className="btn-cancel"
                                    onClick={this.onCloseWaypointsModal.bind(this)}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn-submit-waypoints"
                                    disabled={
                                        this.state.waypointsList.length > 0 &&
                                        this.state.waypointsList.filter(
                                            wp => typeof wp.value === "string" && wp.value.trim()
                                        ).length === 0
                                    }
                                >
                                    <i className="fa fa-check"></i>
                                    Submit Waypoints
                                </button>
                            </div>
                        </form>
                    </div>
                </Modal>

                {/* ── Bulk Upload Modal (New Data only) ───────────────── */}
                <Modal
                    open={this.state.bulkUploadModal}
                    onClose={this.onCloseBulkUploadModal.bind(this)}
                    classNames={{ overlay: "waypoints-modal-overlay" }}
                    closeOnEsc={true}
                    closeOnOverlayClick={!this.state.bulkUploading}
                    showCloseButton={true}
                >
                    <div style={{ padding: "10px 6px", minWidth: "420px" }}>
                        <h5 className="mb-3">
                            <i className="fa fa-upload mr-2"></i>
                            Bulk Upload Routes (New Data)
                        </h5>
                        <p className="mb-2" style={{ fontSize: "13px", color: "#555" }}>
                            Upload an Excel (.xlsx/.xls) or CSV (.csv) file with columns:
                            <strong> Plant</strong>, <strong>City</strong>, optional <strong>Zone</strong>,
                            <strong> State</strong>, <strong>Milestone1…N</strong>, and <strong>Maps Link</strong>.
                            Routes are generated using the same Google routing pipeline as manual creation.
                        </p>
                        <div className="form-group mb-3">
                            <input
                                type="file"
                                accept=".xlsx,.xls,.csv"
                                onChange={this.onBulkFileChange}
                                disabled={this.state.bulkUploading}
                            />
                            {this.state.bulkFileName ? (
                                <div className="mt-2" style={{ fontSize: "12px" }}>
                                    Selected: <strong>{this.state.bulkFileName}</strong>
                                </div>
                            ) : null}
                        </div>
                        <div className="d-flex justify-content-end">
                            <button
                                type="button"
                                className="btn btn-secondary bd-r-8 mr-2"
                                onClick={this.onCloseBulkUploadModal.bind(this)}
                                disabled={this.state.bulkUploading}
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn btn-success bd-r-8"
                                onClick={this.onSubmitBulkUpload}
                                disabled={this.state.bulkUploading || !this.state.bulkFile}
                            >
                                <i className="fa fa-upload mr-2"></i>
                                {this.state.bulkUploading ? "Uploading…" : "Upload"}
                            </button>
                        </div>
                    </div>
                </Modal>

                {/* ── Bulk Upload Validation Summary Modal ────────────── */}
                <Modal
                    open={this.state.bulkValidationModal}
                    onClose={this.onCloseBulkValidationModal.bind(this)}
                    classNames={{ overlay: "waypoints-modal-overlay" }}
                    closeOnEsc={true}
                    closeOnOverlayClick={true}
                    showCloseButton={true}
                >
                    <div style={{ padding: "10px 6px", minWidth: "560px", maxWidth: "760px" }}>
                        <h5 className="mb-3">
                            <i className="fa fa-list-alt mr-2"></i>
                            Bulk Upload Summary
                        </h5>
                        {this.state.bulkSummary ? (
                            <React.Fragment>
                                <div className="row mb-3" style={{ fontSize: "13px" }}>
                                    <div className="col-4 mb-1">Total Rows: <strong>{this.state.bulkSummary.totalRows}</strong></div>
                                    <div className="col-4 mb-1">Processed: <strong>{this.state.bulkSummary.processedRows}</strong></div>
                                    <div className="col-4 mb-1" style={{ color: "#157254" }}>Saved: <strong>{this.state.bulkSummary.successfulRows}</strong></div>
                                    <div className="col-4 mb-1" style={{ color: "#c0392b" }}>Failed: <strong>{this.state.bulkSummary.failedRows}</strong></div>
                                    <div className="col-4 mb-1">Duplicates: <strong>{this.state.bulkSummary.duplicateRows}</strong></div>
                                    <div className="col-4 mb-1">Validation Errors: <strong>{this.state.bulkSummary.validationFailures}</strong></div>
                                    <div className="col-4 mb-1">Google Failures: <strong>{this.state.bulkSummary.googleFailures}</strong></div>
                                </div>

                                {this.state.bulkSummary.errors && this.state.bulkSummary.errors.length ? (
                                    <React.Fragment>
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <span style={{ fontWeight: 600 }}>Errors ({this.state.bulkSummary.errors.length})</span>
                                            <button
                                                type="button"
                                                className="btn btn-primary btn-sm bd-r-8"
                                                onClick={this.downloadBulkErrorReport}
                                            >
                                                <i className="fa fa-download mr-1"></i> Download Error Report
                                            </button>
                                        </div>
                                        <div style={{ maxHeight: "320px", overflowY: "auto", border: "1px solid #eee" }}>
                                            <table className="table table-sm table-striped mb-0" style={{ fontSize: "12px" }}>
                                                <thead>
                                                    <tr>
                                                        <th>Row</th>
                                                        <th>Column</th>
                                                        <th>Value</th>
                                                        <th>Reason</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.bulkSummary.errors.map((err, i) => (
                                                        <tr key={i}>
                                                            <td>{err.row}</td>
                                                            <td>{err.column}</td>
                                                            <td>{err.value}</td>
                                                            <td>{err.message}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </React.Fragment>
                                ) : (
                                    <div style={{ color: "#157254" }}>All rows processed successfully.</div>
                                )}
                            </React.Fragment>
                        ) : null}

                        <div className="d-flex justify-content-end mt-3">
                            <button
                                type="button"
                                className="btn btn-secondary bd-r-8"
                                onClick={this.onCloseBulkValidationModal.bind(this)}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

/* ─── Helpers ─────────────────────────────────────────────── */

function loadScript(url) {
    var index = window.document.getElementsByTagName("script")[0];
    var script = window.document.createElement("script");
    script.src = url;
    script.async = true;
    script.defer = true;
    index.parentNode.insertBefore(script, index);
}

function buildWaypointColumns(
    row,
    exportRow,
    maxWaypoints
) {

    const sortedWaypoints =
        (row.waypoints || [])
            .sort(
                (a, b) =>
                    a.order - b.order
            );

    for (
        let i = 0;
        i < maxWaypoints;
        i++
    ) {

        let exportRow = {

            Source:
                map_plants[
                row.consigner_code
                ] ||
                row.consigner_code,

            Destination:
                row.consignee_city,

            "Hero SAP Distance (Km)":
                row.expected_distance,

            "Google Distance (Km)":
                row.google_distance_via_waypoints
        };
    }

    return exportRow;
}

function buildExportData(
    rowData,
    waypointExportMode
) {

    const exportData = [];

    let maxWaypoints = 0;

    if (
        waypointExportMode ===
        "multiple_columns"
    ) {

        rowData.forEach(row => {

            maxWaypoints =
                Math.max(
                    maxWaypoints,
                    row.waypoints
                        ? row.waypoints.length
                        : 0
                );
        });
    }

    rowData.forEach(row => {

        let exportRow = {

            Source:
                row.consigner_code,

            Destination:
                row.consignee_city,
            "Hero SAP Distance (Km)":
                row.expected_distance || 0,

            "Google Distance (Km)":
                row.google_distance_via_waypoints || 0
        };

        if (
            waypointExportMode ===
            "single_column"
        ) {

            exportRow.Waypoints =
                getWaypointText(
                    row.waypoints
                );
        }
        else {

            exportRow =
                buildWaypointColumns(
                    row,
                    exportRow,
                    maxWaypoints
                );
        }

        exportData.push(exportRow);
    });

    return exportData;
}

function getWaypointText(waypoints) {

    if (
        !waypoints ||
        !waypoints.length
    ) {
        return "";
    }

    return waypoints
        .sort(
            (a, b) =>
                a.order - b.order
        )
        .map(
            wp =>
                wp.location
        )
        .join(" -> ");
}


// /* eslint-disable array-callback-return */
// /* eslint-disable eqeqeq */
// import React, { Component } from 'react';
// import ReactDOM from 'react-dom';

// import _ from "lodash";
// import Modal from 'react-responsive-modal';
// import { Map, InfoWindow, Marker, GoogleApiWrapper, Polygon, Polyline } from 'google-maps-react';

// import axios from 'axios';
// import { AgGridReact } from '@ag-grid-community/react';
// import {AllModules} from '@ag-grid-enterprise/all-modules';
// import "@ag-grid-enterprise/all-modules/dist/styles/ag-grid.css";
// import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
// import Select from 'react-select';

// import SweetAlert from 'react-bootstrap-sweetalert';
// import DrawMap from '../common/drawmap';
// import MyHeaderComponent from "./deviationheaderaction";
// import Showtolls from "./showtolls";
// import ShowChokePoints from "./showchokepoints";
// import ShowTollsList from "./showtollslist";
// import TollGrid from "./deviationtollgrid";
// import ChokePointsGrid from "./deviationchokepoints";
// import ApprovalDeviationRoute from "./approvaldeviationroute";
// import DateDeviationRoute from "./datedeviationroute";
// import ViewDeviationRouteData from "./viewdeviationroutedata";
// import RouteGrid from "./deviationroutedata";
// import $ from 'jquery';
// import { getHyphenYYYYMMDD, getHyphenYYYYMMDDHHMMSS, getDDMMYYYYHHMMSS } from '../common/utils';
// var moment = require('moment');
// var redirectURL = require('../redirectURL');
// var googleAnalytics = require("../common/googleanalytics");
// var aggriddata = [];
// var originaldata;
// var infoBox = require('../common/google-infowindow');
// const map_plants = {"HM4N": "Neemrana", "HHHU": "Haridwar", "HHHD": "Dharuhera", "HHHG": "Gurgaon", "HM5V": "Halol", "HM6C": "Chittoor","HE6C":"Chittoor-EV", "HP3N":"Neemrana" }
// const plant_coords = {"HM4N": {"lat": 27.968191,"lng":76.37616}, "HHHU" : {"lat":29.95923,"lng":78.06932},"HHHD":{"lat":28.232288,"lng": 76.801254},"HHHG":{"lat": 28.434471,"lng": 77.01585}, "HM5V" :{"lat": 22.572409,"lng":73.46393},"HM6C" :{"lat": 13.533582,"lng": 79.955086},"HE6C" :{"lat": 13.533582,"lng": 79.955086},"HP3N" :{"lat": 27.96735,"lng": 76.37214}   }
// var map;
// var waypoints = [];
// var globalWayPointCount = 0;
// var directionsDisplays = [];


// export default class SavedBaseRoutes extends Component {

//     constructor(props) {
//         super(props);
// 		this.displayData = [];
//         this.state = {
//             loadshow:'show-n',
//             overly:'show-n',
// 			modules: AllModules,
//         	alert:null,
//             show: false,
//             basicTitle:'',
//             basicType:"default",
// 			dept_code:'',
// 			defaultColDef: {
// 				sortable: true,
// 				filter: true,
//                 //editable: true,
//                 autoHeight:true,
// 				resizable: true,
//                 width: 130
// 			},
// 			rowData: [],
//             headerHeight: 60,
//             rowHeight:50,
// 			rowModelhighchartoptionsType: 'enterprise',
// 			rowGroupPanelShow: 'always',
// 			animateRows: true,
// 			debug: true,
//             showToolPanel: false,
//             griddata:[],
//             routeRowData:{},
// 			rowSelection: "single" ,
// 			context: { componentParent: this },
//             frameworkComponents: {
//                 MyHeaderComponent: MyHeaderComponent,
//                 Showtolls:Showtolls,
//                 ShowTollsList:ShowTollsList,
//                 ApprovalDeviationRoute:ApprovalDeviationRoute,
//                 DateDeviationRoute:DateDeviationRoute,
//                 ViewDeviationRouteData:ViewDeviationRouteData,
//                 ShowChokePoints:ShowChokePoints
//             },
// 			loadingCellRenderer: "customLoadingCellRenderer",
// 			loadingCellRendererParams: { loadingMessage: "One moment please..." },
// 			rowModelType: "serverSide",
// 			paginationPageSize:50,
// 			cacheBlockSize: 50,
// 			maxBlocksInCache: 2,
//             pageTitle:"Summary",
//             originaldata:"",
//             orignalresponse:"",
//             mapinfo:"",
//             originoption:   {"value":"ALL","label":"ALL"},
//             destinationoption:  {"value":"ALL","label":"ALL"},
//             destinationarr:[],
//             selectedorigin:'',
//             selecteddestination:'',
//             columnDefs: [],
//             checkedinputs:[],
//             uncheckedinputs:[],
//             noofroutes:3,
//             tolls:[],
//             tollshow:false,
//             plantcoords:"",
//             plantname:"",
//             sliderTranslate:"",
//             viewtolls:[],
//             tollrowid:"",
//             routeid:"",
//             routeapprovestatus:"",
//             open:false,
//             route_reason:"",
//             gridapi: [],
//             viewroutedata:[],
//             sliderRouteTranslate:"",
//             sliderRouteTranslate1:"",
//             sliderChokeTranslate:"",
//             chokepoints:[],
//             chokepointdata:[],
//             originoptions:[],
//             btn1: "btn-default",
//             btn2: "btn-default",
//             btn3: "btn-default",
//             btn4: "btn-default",
//             complete_analysis: [],
//             base_routes_anlsysis: [],
//             transporters_analysis: [],
//             complete_trips: [],
//             breaks_list: [],
//             route_coords: [],
//             gridHeight: "160px",
//             "mapfor": "",
//             destinationOptions: [],
//             defaultTrips: [],
//             selectedRoutes: [],
//             dealersList : [],
//             route_coords1: [],
//             breaks_list1: [],
//             tripsGridApi: {},
//             defaultCompleteTrips: [],
//             hideSummaryTab: false,
//             lspusers_options: [],
//             truck_types: [],
//             period_types: [],
//             selected_provider: {"label": "ALL", "value": "ALL"},
//             selected_truck_type: {"label": "ALL", "value": "ALL"},
//             selected_period_type: {"label": "ALL", "value": "ALL"},
//             coords_to_plot: [],
//             google_distance_via_waypoints: 0,
//             expected_distance: 0,
//             consigner_coordinates: {},
//             savedBaseRoutes: [],
//             selectedSource: "",
//             selectedCity: "",
//             alteredHeroSapRoute: {},
//             heroSapRoute: "",
//             waypointsmodal: false,
//             selectedRow: {},
//             addNewWayPoints: [],
//             existing_route: false,
//             changedWaypoints: [],
//             defaultRowData: []
//         };
//         this.onLoadFormRequest = this.onLoadFormRequest.bind(this);
// 	}
// 	/*Alert Popups*/
// 	closeAlert = () => {
//         this.setState({
//             show: false
//         });
//     }

// 	hideAlert = () => {
//         this.setState({
//             alert: null
//         });
// 	}
// 	onCloseWaypointsModal(){
//         this.setState({
//             waypointsmodal: false
//         })
//     }
//     componentDidMount(){
//         var dept_code = this.props.match.path == "/herosaproutes"?"SNDG":"LOG-PRT"
//         this.setState({
//             dept_code:dept_code,
//             overly: "show-m",
//             loadshow: "show-m"
//         })
//         var query = {dept_code:dept_code}

//         var map_plants = {"HM4N": "Neemrana", "HHHU": "Haridwar", "HHHD": "Dharuhera", "HHHG": "Gurgaon", "HM5V": "Halol", "HM6C": "Chittoor","HE6C":"Chittoor-EV", "HP3N":"Neemrana" }
//         redirectURL.post("/dashboard/getInitialDataForHeroSapRoutes",query).then((response) => {
//             var plantdata = response.data.consigners;
//             var originoptions = [{ "label": "ALL", "value": "ALL" }];
//             plantdata.map((item) => {
//                 originoptions.push({
//                     value: item,
//                     label: map_plants[item]
//                 })
//             })
//             var destinationOptions = [{ "label": "ALL", "value": "ALL" }];
//             var destinationarr = response.data.destinations;
//             var destinationarr = destinationarr.map(city =>
//                 city.replace(/([^\(\)]+)/g, match =>
//                     match.toLowerCase().replace(/\b\w/g, c => c.toUpperCase())
//                 )
//             );
//             destinationarr.map((item) => {
//                 destinationOptions.push({
//                     value: item, label: item
//                 })
//             })
//             this.setState({
//                 originoptions: originoptions,
//                 destinationOptions: destinationOptions,
//                 destinationarr
//             })
//         })
//         redirectURL.post("/dashboard/getAllSavedBaseRoutes", query).then((response) => {
//             let rowData = response.data.savedBaseRoutes;
//             let destinationarr = this.state.destinationarr;
//             let destinationOptions = this.state.destinationOptions;
//             const uniqueCities = new Set(destinationarr.map(city => city.toLowerCase())); // Create a Set to track unique consignee cities
//             rowData.forEach(e => {
//                 const city =  e.consignee_city ? e.consignee_city.toLowerCase() : '';// Transform the city name to the desired format                
//                 if (!uniqueCities.has(city)) {
//                     const formattedCity = e.consignee_city
//                     ? e.consignee_city.replace(/([^\(\)]+)/g, match =>
//                         match.toLowerCase().replace(/\b\w/g, c => c.toUpperCase())
//                     ): "";
//                     const data_check = { value: formattedCity, label: formattedCity }; // Create the new entry for destinationOptions                    
//                     destinationOptions.push(data_check);// Push to destinationOptions and add to the uniqueCities set
//                     uniqueCities.add(city);
//                 }
//             });
//             this.setState({
//                 savedBaseRoutes: response.data.savedBaseRoutes,
//                 rowData: response.data.savedBaseRoutes,
//                 overly: "show-n",
//                 loadshow: "show-n",
//                 destinationOptions
//             })
//             this.renderMap()
//         })
// 	}
	
// 	logPageView = () => {
// 		try {
// 		    if (googleAnalytics.page.enableGA) {
// 		        googleAnalytics.logPageView();
// 		        let eventGridAction = googleAnalytics.page.actionType.gridAction + " - " + window.location.pathname;
// 		        let eventCounterAction = googleAnalytics.page.actionType.counterAction + " - " + window.location.pathname;
// 		        let eventFormAction = googleAnalytics.page.actionType.formAction + " - " + window.location.pathname;
// 		        this.setState({eventGridAction: eventGridAction, eventCounterAction: eventCounterAction, eventFormAction: eventFormAction});
// 		    } else {
// 		        console.log("GA disabled...");
// 		    }
// 		} catch(error) {
// 		    console.error("Error occured while logging to GA, error = ", error);
// 		}
// 	}

// 	onGridReady = params => {
// 		this.gridApi = params.api;
//         this.setState({
//             gridapi : params.api
//         })
//         this.gridColumnApi = params.columnApi;
//         var sort = [
// 			{
// 			  colId: 'no_of_followers_percentage',
// 			  sort: 'desc',
// 			},
// 		  ];
// 		this.gridApi.setSortModel(sort);
//         this.gridApi.addEventListener('paginationChanged', (e) =>
//         {
//             //Reset rows selection based on current page
//            // this.resetPaginationSelection(this);
//         });

//         this.gridApi.forEachLeafNode( (node) => {
//             // console.log("node here ",node)
//             // node.setSelected(true);
         
//         });
        
// 	};

// 	onGridState = () =>{
// 		//  console.log(this.gridApi);
		
// 		 /*Get  Current Columns State and Store in this.colState */
// 		   this.colState = this.gridColumnApi.getColumnState();

// 		 /*Get Current RowGroup Columns State and Store in this.rowGroupState */
// 		   this.rowGroupState = this.gridColumnApi.getRowGroupColumns();

// 		 /*Get Current Pivot Columns State and Store in this.pivotColumns, 
// 		  * User should enable the Pivot mode.*/
// 		   this.pivotColumns = this.gridColumnApi.getPivotColumns();
		 		   
// 		 /*Get Current Filter State and Store in window.filterState */
// 		   window.filterState = this.gridApi.getFilterModel();
//            this.gridApi.setFilterModel(window.filterState);
           

           
        
//         //
//     }

// 	changeOriginHandler = originoption => {
//         this.setState(
//             { originoption }
//         );
//     }

//     changeDestinationHandler = destinationoption => {
//         this.setState(
//             { destinationoption }
//         );
    
//     }

// 	formHandler = (event) =>{
//         event.preventDefault();
//        // loadchecked()
// 		if (googleAnalytics.page.enableGA) {
// 			let pageTitle = this.state.pagetitle;
// 			let eventOptions = {
// 				"category": pageTitle,
// 				"action": this.state.eventGridAction,
// 				"label": googleAnalytics.page.action.formAction,
// 			}
// 			googleAnalytics.logEvent(eventOptions);
// 		}
//         try{
//             var tcheck = document.getElementById("tollcheck")
//             if(tcheck.checked == true)
//             {
//                 tcheck.checked = false;
//             }
//         }
//         catch(e){

//         }
// 		this.setState({
//             loadshow:'show-m',            
//             tolllist:[]
//         });
//         if(this.state.originoption.value != "" && this.state.destinationoption.value != "")
//         {

//             var formdata = {
//                 consigner_code:this.state.originoption.value,
//                 consignee_city:this.state.destinationoption.value,
//             }
//             this.setState({
//                 selectedSource: this.state.originoption.value,
//                 selectedCity: this.state.destinationoption.value
//             })
//             // console.log(formdata)
//             this.gridApi.forEachNode((node)=> { 
//                 if(node.data.consigner_code == this.state.originoption.value && node.data.consignee_city == this.state.destinationoption.value){
//                     node.setSelected(true)
//                 }
//             });
//             if (this.state.originoption.value == "ALL" || this.state.destinationoption.value == "ALL") {
//                 let filterData = this.state.savedBaseRoutes;
//                 const { originoption, destinationoption } = this.state;
//                 if (originoption.value !== "ALL" && destinationoption.value === "ALL") { // Filter based on origin and destination options
//                     filterData = filterData.filter(item =>
//                         item.consigner_code.toLowerCase() === originoption.value.toLowerCase()
//                     );
//                 } else if (originoption.value === "ALL" && destinationoption.value !== "ALL") {
//                     filterData = filterData.filter(item =>
//                         item.consignee_city.toLowerCase() === destinationoption.value.toLowerCase()
//                     );
//                 }
//                 if (filterData.length === 0) {
//                     this.setState({
//                         basicTitle: "No Hero SAP Route marked",
//                         basicType: "warning",
//                         show: true,
//                         coords_to_plot: [],
//                         consigner_coordinates: {},
//                         heroSapRoute: [],
//                         rowData: []
//                     });
//                     this.gridApi.deselectAll();
//                 } else {
//                     this.setState({
//                         rowData: filterData,
//                         loadshow: "show-n",
//                         overly: "show-n",
//                         coords_to_plot: [],
//                         consigner_coordinates: {},
//                         heroSapRoute: []
//                     });
//                 }
//                 this.renderMap();
//             }
//             else{
//                 this.onLoadFormRequest(formdata)
//             }
//         }
//         else
//         {
//             this.setState({
//                 basicTitle: "Please select Consigner and Consignee City",
//                 basicType: "warning",
//                 show: true,
//                 overly: "show-n",
//                 loadshow: "show-n"
//             })
//         }
		
//     }
    
//     onLoadFormRequest(formdata)
//     { 
//         this.setState({
//             loadshow: "show-m",
//             overly: "show-m"
//         })
//         // console.log("formdata",formdata)
//         // console.log("this.state.savedBaseRoutes",this.state.savedBaseRoutes)
//         // var filteredData = this.state.savedBaseRoutes.filter(e => 
//         //     e.consigner_code.trim().toLowerCase() === formdata.consigner_code.trim().toLowerCase() && 
//         //     e.consignee_city.trim().toLowerCase() === formdata.consignee_city.trim().toLowerCase()
//         // );
//         var filteredData = this.state.savedBaseRoutes.filter(e => 
//            e.consigner_code && (e.consigner_code.trim().toLowerCase() === formdata.consigner_code.trim().toLowerCase()) && 
//             e.consignee_city && (e.consignee_city.trim().toLowerCase() === formdata.consignee_city.trim().toLowerCase())
//         );
        
//         if(filteredData.length == 0)
//         {
//             this.setState({
//                 basicTitle: "No Hero SAP Route marked",
//                 basicType: "warning",
//                 show: true,
//                 coords_to_plot: [],
//                 consigner_coordinates: {},
//                 heroSapRoute: [],
//                 rowData: []
//             })
//             this.gridApi.deselectAll();
//             this.renderMap()
//         }
//         else
//         {
//             var formdata = {
//                 "plant_code": this.state.originoption.value,
//                 "consigner_code": formdata.consigner_code,
//                 "consignee_city": formdata.consignee_city,
//                 "dept_code": this.state.dept_code
//             }
//             redirectURL.post("dashboard/getConsignerCoordinates", formdata).then((resp)=>{
//                 var coords_to_plot = [];
//                 var alteredHeroSapRoute = [];
//                 if(resp.data.map_coords.length)
//                 {
//                     if(resp.data.map_coords.route_coords != undefined)
//                     {
//                         coords_to_plot = eval(resp.data.map_coords[0].route_coords)
//                     }
//                     if(resp.data.map_coords[0].alteredHeroSapRoute != undefined)
//                     {
//                         alteredHeroSapRoute = JSON.parse(decodeURI(resp.data.map_coords[0].alteredHeroSapRoute))
//                     }
//                 }
                
//                 this.setState({
//                     coords_to_plot: coords_to_plot,
//                     heroSapRoute: alteredHeroSapRoute,
//                     google_distance_via_waypoints: filteredData[0]['google_distance_via_waypoints'],
//                     expected_distance: filteredData[0]['expected_distance'],
//                     consigner_coordinates: resp.data.consigner_coords,
//                     selectedRow: filteredData[0],
//                     rowData: filteredData
//                 })
//                 this.gridApi.selectAll();
//                 this.renderMap()
//             })
//         }
//         // redirectURL.post("dashboard/getSavedBaseRoute", formdata).then((response)=>{
//         //     console.log(response.data)
//         //     if(response.data.length == 0)
//         //     {
//         //         this.setState({
//         //             basicTitle: "No Hero SAP Route marked",
//         //             basicType: "warning",
//         //             show: true,
//         //             coords_to_plot: [],
//         //             consigner_coordinates: {}
//         //         })
//         //         this.renderMap()

//         //     }
//         //     else
//         //     {
//         //         var formdata = {
//         //             "plant_code": this.state.originoption.value
//         //         }
//         //         redirectURL.post("dashboard/getConsignerCoordinates", formdata).then((resp)=>{
//         //             console.log("consigner_coordinates", resp.data, typeof(resp.data))
//         //             this.setState({
//         //                 coords_to_plot: eval(response.data[0]['route_coords']),
//         //                 google_distance_via_waypoints: response.data[0]['google_distance_via_waypoints'],
//         //                 expected_distance: response.data[0]['expected_distance'],
//         //                 consigner_coordinates: resp.data
//         //             })
//         //             this.renderMap()

//         //         })
                
//         //     }
            
//         // })
//     }

// 	onClickHideAll(){
// 		this.setState({
// 			loadshow:'show-n',
// 			overly:'show-n',
//             sliderTranslate:'',
//             sliderRouteTranslate:'',
//             sliderChokeTranslate:""
// 		});
		
//     }

//     changeHandler(event){
//         let name = event.target.name;
//         let value = event.target.value;
//         this.setState({
//             [name]:value
//         });
//     }

//     renderMap = () => {    	
//         loadScript("https://maps.googleapis.com/maps/api/js?key=AIzaSyBQUmk7hdajZEAYllxKhVPnUx5pXuK-j_Y&libraries=places,drawing,geometry&callback=initMapWeather");
//         window.initMapWeather = this.initMap
//     }

//     initMap = () => {
//         this.setState({
//             overly: "show-m",
//             loadshow: "show-m"
//         })
//         var heroSapRoutePresent = 0
//         if(this.state.heroSapRoute != undefined)
//         {
//             if(this.state.heroSapRoute != "")
//             {
//                 heroSapRoutePresent = 1
//             }
//         }
//         var arr2 = this.state.coords_to_plot;
//         waypoints = [];
//         // for waypoints
//         if(arr2.length && heroSapRoutePresent == 0)
//         {
//             var freq = Math.round(arr2.length / 25)
//             var start_index = freq;
//             for(var i=1;i<26;i++)
//             {
//                 // console.log(i, start_index)
//                 try{
//                     waypoints.push({
//                         location: new window.google.maps.LatLng(arr2[start_index].lat, arr2[start_index].lng),
//                         stopover: true,
//                     });
//                     start_index += freq
//                 }
//                 catch(e){
//                     break
//                 }
//             }
            
//         }
//         try{
//             var map_type = window.google.maps.MapTypeId.ROADMAP;
//             map = new window.google.maps.Map(document.getElementById('map'), {
//                 // zoom: 8,
//                 center: new window.google.maps.LatLng(28.497236,77.062363),
//                 mapTypeId: map_type,
//                 mapTypeControl: true,
//                 mapTypeControlOptions: {
//                     style: window.google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
//                     position: window.google.maps.ControlPosition.TOP_RIGHT
//                 },            
//                 disableDefaultUI: true,
//                 fullscreenControl: true,
//                 zoomControl: true,
//                 panControl: false,
                
//             });

//             var bounds = new window.google.maps.LatLngBounds();
            
//             bounds.extend(new window.google.maps.LatLng(23.63936, 68.14712));
//             bounds.extend(new window.google.maps.LatLng(28.20453, 97.34466));
            
//             // for (var i = 0; i < arr2.length - 1; i++) {
//             //     var locationLatLng = [];
//             //     locationLatLng.push(new window.google.maps.LatLng(arr2[i].lat, arr2[i].lng));
//             //     locationLatLng.push(new window.google.maps.LatLng(arr2[i + 1].lat, arr2[i + 1].lng));
                
//             //     var consignments_missing_route_line = new window.google.maps.Polyline({
//             //         map: map,
//             //         path: locationLatLng,
//             //         strokeColor: '#157254',
//             //         strokeOpacity: .3,
//             //         strokeWeight: 2.5,
//             //         icons: []
//             //     });

//             //     var is_straight_line = 0
//             //     if(arr2[i].dist_from_prev_point >= 20000)
//             //     {
//             //         is_straight_line = 1
//             //     }
//             //     if (arr2[i].msgtype == "G") {
//             //         consignments_missing_route_line.setOptions({
//             //             strokeColor: "#452a68",
//             //             strokeWeight: 5.5,
//             //         })
//             //     }
//             //     if (arr2[i].set == undefined && arr2[i].msgtype != "G") {
//             //         consignments_missing_route_line.setOptions({
//             //             strokeColor: "#157254"
//             //         })
//             //     }
//             //     else if (arr2[i].set == 1 && arr2[i].msgtype != "G" ) {
//             //         consignments_missing_route_line.setOptions({
//             //             strokeColor: "#157254"
//             //         })
//             //     }
//             //     else if (arr2[i].set == 2 && arr2[i].msgtype != "G" ) {
//             //         consignments_missing_route_line.setOptions({
//             //             strokeColor: "#0000ff",
//             //             strokeWeight: 5.5,
//             //         })
//             //     }
//             //     else if (arr2[i].set == 3 && arr2[i].msgtype != "G") {
//             //         consignments_missing_route_line.setOptions({
//             //             strokeColor: "#980000",
//             //             strokeWeight: 5.5,
//             //         })
//             //     }
                
//             //     if(is_straight_line)
//             //     {
//             //         consignments_missing_route_line.setOptions({
//             //             strokeColor: "red",
//             //             strokeWeight: 3.5,
//             //         })
//             //     }
//             //     bounds.extend(new window.google.maps.LatLng(arr2[i].lat, arr2[i].lng));
//             // }
//             if(arr2.length && heroSapRoutePresent == 0)
//             {
//                 this.plotGoogleDirections(new window.google.maps.LatLng(arr2[0].lat, arr2[0].lng),
//                 new window.google.maps.LatLng(arr2[(arr2.length - 1)].lat, arr2[(arr2.length - 1)].lng))
//             }
//             else{
//                 // console.log(this.state.heroSapRoute, "herosap")
//                 waypoints = this.state.heroSapRoute.request.waypoints;
//                 // let origin = plant_coords[map_plants[this.state.selectedRow['consigner_code']]]
//                 let origin = plant_coords[this.state.selectedRow['consigner_code']]
//                 let source = new window.google.maps.LatLng(origin.lat, origin.lng)
//                 this.plotGoogleDirections(source,this.state.selectedRow['consignee_city'])
//             }


//         }catch(e){
//             console.log(e, "error")
//         }
//         try{
//             //plant icon
//             let plantLat = this.state.consigner_coordinates.lat;
//             let plantLng = this.state.consigner_coordinates.lng;

//             let plantMarker = new window.google.maps.Marker({
//                 position: new window.google.maps.LatLng(plantLat, plantLng),
//                 icon: require('../../assets/icons/business.png'),
//                 map
//             })
//             var infowindow = new window.google.maps.InfoWindow();
//             window.google.maps.event.addListener(plantMarker, 'mouseover', ( (plantMarker, index)=> {
//                 return  ()=> {
//                     var contentarr = []
//                     var header = "Plant"
//                     contentarr.push({"key":"Plant", "value": this.state.selectedSource})
//                     var contentString = infoBox(plantMarker.icon, header, contentarr)
//                     infowindow.setContent(contentString);
//                     var currentwindow = infowindow;
//                     infowindow.open(map, plantMarker);
//                 }
//             })(plantMarker,));
//             window.google.maps.event.addListener(plantMarker, 'mouseout', function () {
//                 infowindow.close();
//             });

//             // ending point
//             var marker = new window.google.maps.Marker({
//                 position: new window.google.maps.LatLng(arr2[(arr2.length - 1)].lat, arr2[(arr2.length - 1)].lng),
//                 icon: require('../../assets/icons/truck-end.png'),
//                 map: map,
//             });
//             window.google.maps.event.addListener(marker, 'click', ( (marker) =>{
//                 return  ()=> {
//                     //	console.log(clusters[0])

//                     //var contentString = "<p style='color:#1F749B'><img src="+marker.icon+">"+"<B> End Point</B></p><p>End at "+routeinfo.end_time+"</p>";
//                     var contentarr = []
//                     //var contentString = "<p style='color:#1F749B'><img src="+marker.icon+">"+"<B> Starting Point</B></p><p>Started at "+routeinfo.start_time+"</p>";
//                     var header = "End Point"
//                     contentarr.push({ "key": "Destination", "value": this.state.selectedCity })

//                     var contentString = infoBox(marker.icon, header, contentarr, '')

//                     infowindow.setContent(contentString);
//                     infowindow.open(map, marker);
//                     // console.log('{"lat":'+marker.position.lat() + ',"lng":' +marker.position.lng() +'}');
//                 }
//             })(marker));
//         }
//         catch(e){
//             console.log("error", e)
//         }
//         map.fitBounds(bounds)
//         this.setState({
//             overly: "show-n",
//             loadshow: "show-n"
//         })
       
        
//     }

//     onCellClicked(cell)
//     {
//         if(cell.colDef.field == "_id")
//         {
//             cell.node.setSelected(true)
//             var formdata = {
//                 "plant_code": cell.data.consigner_code,
//                 "consigner_code": cell.data.consigner_code,
//                 "consignee_city": cell.data.consignee_city,
//                 "dept_code":this.state.dept_code,
//             }
//             redirectURL.post("dashboard/getConsignerCoordinates", formdata).then((resp)=>{
//                 var heroSapRoute = [];
//                 var coords_to_plot = [];
//                 if(resp.data.map_coords.length)
//                 {
//                     if(resp.data.map_coords[0].route_coords != undefined)
//                     {
//                         coords_to_plot = eval(resp.data.map_coords[0].route_coords)
//                     }
//                     if(resp.data.map_coords[0].alteredHeroSapRoute != undefined)
//                     {
//                         heroSapRoute = JSON.parse(decodeURI(resp.data.map_coords[0].alteredHeroSapRoute))
//                     }
//                 }
//                 this.setState({
//                     coords_to_plot: coords_to_plot,
//                     heroSapRoute: heroSapRoute,
//                     google_distance_via_waypoints: cell.data['google_distance_via_waypoints'],
//                     expected_distance: cell.data['expected_distance'],
//                     consigner_coordinates: resp.data.consigner_coords,
//                     selectedSource: map_plants[cell.data.consigner_code],
//                     selectedCity: cell.data.consignee_city,
//                     selectedRow: cell.data,
//                     existing_route: true
//                 })
//                 this.renderMap()
//             })
//         }
//         else if(cell.colDef.field == "add_way_points")
//         {
//             this.setState({
//                 waypointsmodal: true,
//                 selectedRow: cell.data,
//                 existing_route: true
//             })
//         }
//     }
//     onRowSelected(cell){
//         // console.log(cell);
//         this.setState({
//             existing_route: true
//         })
//     }
    
//     onClickSaveRoute()
//     {
//         let selectedNodes = this.gridApi.getSelectedNodes();
//         if(selectedNodes.length || this.state.existing_route == false)
//         {
//             let selectedData = selectedNodes.map(node => node.data);
//             var alteredHeroSapRoute = this.state.alteredHeroSapRoute;
//             if(Object.keys(alteredHeroSapRoute).length || this.state.addNewWayPoints.length)
//             {
//                 // console.log(alteredHeroSapRoute, "alteredHeroSapRoute")
//                 if(this.state.existing_route)
//                 {
//                     var formdata = {
//                         "row_id": selectedData[0]['_id'],
//                         alteredHeroSapRoute: encodeURI(JSON.stringify(alteredHeroSapRoute)),
//                         existing_route: this.state.existing_route
//                     }
//                 }
//                 else{
//                     var expected_distance = 0
//                     alteredHeroSapRoute.routes[0].legs.map((e)=>{
//                         expected_distance = expected_distance + e.distance.value
//                     })
//                     expected_distance = Math.round(expected_distance / 1000)
//                     var formdata = {
//                         consigner_code: this.state.originoption.value,
//                         // consignee_city: this.state.destinationoption.value,
//                         consignee_city: this.state.destination_new,
//                         alteredHeroSapRoute: encodeURI(JSON.stringify(alteredHeroSapRoute)),
//                         existing_route: this.state.existing_route,
//                         created_by: localStorage.getItem("email"),
//                         expected_distance: expected_distance,
//                         google_distance_via_waypoints: expected_distance
//                     }
//                 }
//                 if(!["",undefined,null,"undefined"].includes(this.state.dept_code)){
//                     formdata.dept_code = this.state.dept_code
//                 }
//                 // console.log(formdata, "formdata")
//                 this.setState({
//                     loadshow: "show-m",
//                     overly: "show-m"
//                 })
//                 redirectURL.post("/dashboard/saveAlteredHeroSapRoute", formdata).then((response)=>{
//                     if(response.data.message == "success")
//                     {
//                         this.setState({
//                             basicTitle: "Saved Successfully",
//                             basicType: "success",
//                             show: true
//                         })
//                     }
//                     else
//                     {
//                         this.setState({
//                             basicTitle: "Unable to store data",
//                             basicType: "warning",
//                             show: true
//                         })
//                     }
//                     this.setState({
//                         loadshow: "show-n",
//                         overly: "show-n"
//                     })
//                 })
//             }
//             else
//             {
//                 this.setState({
//                     basicTitle: "Route unchanged",
//                     basicType: "warning",
//                     show: true
//                 })
//             }
            
//         }
//         else
//         {
//             this.setState({
//                 basicTitle: "Select atleast one route",
//                 basicType: "warning",
//                 show: true
//             })
//         }

//     }

//     // plotSavedGoogleDirections(start, end) {
//     //     var routes = response.routes;
//     //     console.log(response, "response")
//     //     var colors = ['#157254'];
//     //     directionsDisplays = [];
    
//     //     // Reset the start and end variables to the actual coordinates
//     //     var start = response.routes[0].legs[0].start_location;
//     //     var end = response.routes[0].legs[0].end_location;
//     //     console.log(start, end)
//     //     // Loop through each route
//     //     for (var i = 0; i < routes.length; i++) {
    
//     //         var directionsDisplay = new window.google.maps.DirectionsRenderer({
//     //         map: map,
//     //         directions: response,
//     //         routeIndex: i,
//     //         draggable: true,
//     //         polylineOptions: {
    
//     //             strokeColor: colors[i],
//     //             strokeWeight: 4,
//     //             strokeOpacity: 1
//     //         }
//     //         });
    
//     //         // Push the current renderer to an array
//     //         directionsDisplays.push(directionsDisplay);
    
//     //         // Listen for the directions_changed event for each route
//     //         window.google.maps.event.addListener(directionsDisplay, 'directions_changed', ((directionsDisplay, i)=> {
    
//     //         return ()=> {
    
//     //             var directions = directionsDisplay.getDirections();
//     //             this.setState({
//     //                 alteredHeroSapRoute: directions
//     //             })
//     //             // var new_start = directions.routes[0].legs[0].start_location;
//     //             // var new_end = directions.routes[0].legs[0].end_location;
    
//     //             // if ((new_start.toString() !== start.toString()) || (new_end.toString() !== end.toString())) {
    
//     //                 // Remove every route from map
//     //                 // for (var j = 0; j < directionsDisplays.length; j++) {
        
//     //                 //     directionsDisplays[j].setMap(null);
//     //                 // }
        
//     //                 // // Redraw routes with new start/end coordinates
//     //                 // this.plotSavedGoogleDirections(new_start, new_end);
//     //             // }
//     //         }
//     //         })(directionsDisplay, i)); // End listener
//     //     } // End route loop
//     // }

//     plotGoogleDirections(start, end) {
//         directionsDisplays.map((e)=>{
//             e.setMap(null)
//         })
//         var directionsService = new window.google.maps.DirectionsService();
    
//         var method = 'DRIVING';
//         // console.log(waypoints, "waypoints")
//         var request = {
//           origin: start,
//           destination: end,
//           travelMode: window.google.maps.DirectionsTravelMode[method],
//           provideRouteAlternatives: false,
//           waypoints: waypoints,
//           optimizeWaypoints: true,
//         };
      
//         directionsService.route(request, (response, status) =>{
      
//           if (status == window.google.maps.DirectionsStatus.OK) {
            
//             var routes = response.routes;
//             // console.log(response, "response")
//             var colors = ['#157254'];
//             directionsDisplays = [];
      
//             // Reset the start and end variables to the actual coordinates
//             // var start = response.routes[0].legs[0].start_location;
//             // var end = response.routes[0].legs[0].end_location;
      
//             // Loop through each route
//             for (var i = 0; i < routes.length; i++) {
                
//               var directionsDisplay = new window.google.maps.DirectionsRenderer({
//                 map: map,
//                 directions: response,
//                 routeIndex: i,
//                 draggable: true,
//                 // suppressMarkers: true,
//                 polylineOptions: {
//                   strokeColor: colors[i],
//                   strokeWeight: 4,
//                   strokeOpacity: 1
//                 }
//               });
//               var directions = directionsDisplay.getDirections();
//               var changedWaypoints = this.state.changedWaypoints;
//               changedWaypoints.push(directions)
//               this.setState({
//                 changedWaypoints: changedWaypoints
//               })
//               // after submitting new waypoints inputs, storing the route to save
//               if(this.state.addNewWayPoints.length)
//               {
//                 this.setState({
//                     alteredHeroSapRoute: directions
//                 })
//               }
      
//               // Push the current renderer to an array
//               directionsDisplays.push(directionsDisplay);
//               // Listen for the directions_changed event for each route
//               window.google.maps.event.addListener(directionsDisplay, 'directions_changed', ((directionsDisplay, i)=> {
      
//                 return ()=> {
      
//                     var directions = directionsDisplay.getDirections();
//                     // var wayPoint = directions.routes[0].legs[0].via_waypoint[0]; //get waypoint as a result of a user dragging

//                     // waypoints.push({
//                     //     location: wayPoint.location,
//                     //     stopover: true
//                     // })
//                     var changedWaypoints = this.state.changedWaypoints;
//                     changedWaypoints.push(directions)

//                     this.setState({
//                         alteredHeroSapRoute: directions,
//                         changedWaypoints: changedWaypoints
//                     })
                
//                     // var new_start = directions.routes[0].legs[0].start_location;
//                     // var new_end = directions.routes[0].legs[0].end_location;
        
//                     // if ((new_start.toString() !== start.toString()) || (new_end.toString() !== end.toString())) {
        
//                     //     // Remove every route from map
//                     //     for (var j = 0; j < directionsDisplays.length; j++) {
        
//                     //     directionsDisplays[j].setMap(null);
//                     //     }
        
//                     //     // Redraw routes with new start/end coordinates
//                     //     this.plotGoogleDirections(new_start, new_end);
//                     // }
//                 }
//               })(directionsDisplay, i)); // End listener
//             } // End route loop
//           }
//         });
//     }

    
//     onClickAddWaypoints(){
//         // let selectedNodes = this.gridApi.getSelectedNodes();
//         // if(selectedNodes.length)
//         // {
//         // let selectedRow = selectedNodes.map(node => node.data);
//         // console.log(selectedRow,"selectedRow")
//         this.setState({
//             waypointsmodal: true,
//             selectedRow: {},
//             existing_route: false
//         })
//         // }
//         // else
//         // {
//         //     this.setState({
//         //         basicTitle: "Please select atleast one route",
//         //         basicType: "warning",
//         //         show: true
//         //     })
//         // }
//     }
//     onFocusSearch(idx){
//         var input = document.getElementById('way_point_search_'+idx);
//         var searchBox = new window.google.maps.places.SearchBox(input);
//         searchBox.addListener('places_changed', function() 
//         {
//           var places = searchBox.getPlaces();
            
//           if (places.length == 0) {
//             return;
//           }
//           var bounds = new window.google.maps.LatLngBounds();
//           places.forEach(function(place) {
//             if (!place.geometry) {
//             //   console.log("Returned place contains no geometry");
//               return;
//             }
            
    
//             if (place.geometry.viewport) {
//               // Only geocodes have viewport.
//               bounds.union(place.geometry.viewport);
//             } else {
//               bounds.extend(place.geometry.location);
//             }
//           });
//         });
//     }

//     onDestinationSearch = () =>{
//         var input = document.getElementById('way_point_destination_search');
//         var searchBox = new window.google.maps.places.SearchBox(input);
//         searchBox.addListener('places_changed', function() 
//         {
//           var places = searchBox.getPlaces();
            
//           if (places.length == 0) {
//             return;
//           }
//           var bounds = new window.google.maps.LatLngBounds();
//           places.forEach(function(place) {
//             if (!place.geometry) {
//             //   console.log("Returned place contains no geometry");
//               return;
//             }
            
    
//             if (place.geometry.viewport) {
//               // Only geocodes have viewport.
//               bounds.union(place.geometry.viewport);
//             } else {
//               bounds.extend(place.geometry.location);
//             }
//           });
//         });

//     }

//     onClickAddNewWayPoint(){
//         // var wrapper = $(".addNewWayPointLink");
//         globalWayPointCount = globalWayPointCount + 1;
//         if(globalWayPointCount > 25)
//         {
//             globalWayPointCount = globalWayPointCount - 1;
//             this.setState({
//                 basicTitle: "Only 25 Way Points are allowed",
//                 basicType:"warning",
//                 show: true
//             })
//         }
//         else
//         {
//             var addNewWayPoints = this.state.addNewWayPoints;
//             addNewWayPoints.push(globalWayPointCount)
//             this.setState({
//                 addNewWayPoints: addNewWayPoints
//             })
//         }
        
//         // $(wrapper).before("<div class='form-group col-xl-12 col-lg-12'><label style='width:100%'>Way Point "+globalWayPointCount+" <i class='fa fa-trash' id='delete_waypoint_"+globalWayPointCount+"' style='color:red;float:right'></i></label><input type='text' name='search' class='form-control' style={{height:'37px'}} id='way_point_"+globalWayPointCount+"' onchange='onWayPointchanged(this);' placeholder='Enter Address to search' autoComplete='new-password' required/></div>"); //add input box
//         // onWayPointchanged()
        
//     }

//     onSubmitWayPoints(e){
//         e.preventDefault();
//         waypoints = []
//         for(var i=1;i<=globalWayPointCount;i++)
//         {
//             var inputVal = $("#way_point_search_"+globalWayPointCount).val();
//             waypoints.push({
//                 location: inputVal,
//                 stopover: true,
//             });
//         }
//         // console.log(waypoints, "waypoints")
//         this.setState({
//             waypointsmodal: false
//         })
//         if(this.state.existing_route)
//         {
//             // let origin = plant_coords[map_plants[this.state.selectedRow['consigner_code']]]
//             let origin = plant_coords[this.state.selectedRow['consigner_code']]
//             let source = new window.google.maps.LatLng(origin.lat, origin.lng)
//             // console.log("origin",origin)
//             // console.log("map_plants", map_plants[this.state.selectedRow['consigner_code']],'\n',this.state.selectedRow['consignee_city'])
//             this.plotGoogleDirections(source,this.state.selectedRow['consignee_city'])
//         }
//         else
//         {
//             let destination_new = $('#way_point_destination_search').val()
//             this.setState({
//                 destination_new
//             })
//             // console.log('destination_new',destination_new)
//             var source = this.state.originoption.label;
//             var destination = this.state.destinationoption.value;            
//             if(['', undefined, null].includes(source) == false && ['', undefined, null].includes(destination) == false)
//             {
//                 redirectURL.post("dashboard/getConsignerCoordinates", {
//                     "plant_code": this.state.originoption.value,
//                     "map_coords": false,
//                     destination,
//                     "consigner_code": this.state.originoption.value,
//                     "consignee_city": this.state.destinationoption.value,
//                     "dept_code": this.state.dept_code
//                 }).then((resp) => {

//                     source = new window.google.maps.LatLng(resp.data.consigner_coords.lat, resp.data.consigner_coords.lng)
//                     // destination = new window.google.maps.LatLng(resp.data.destinationCoords.lat, resp.data.destinationCoords.lng)
//                     // console.log("source",source,'\n destination',destination)
//                     this.gridApi.deselectAll();
//                     this.plotGoogleDirections(source, destination_new)

//                 })
//             }
//             else
//             {
//                 this.gridApi.deselectAll();
//                 this.setState({
//                     basicTitle: "Source & Destination should be selected",
//                     basicType: "warning",
//                     show: true
//                 })
//             }
            
//         }
        
//     }

//     onClickRemoveWayPoint(idx){
//         // console.log(idx)
//         var addNewWayPoints = this.state.addNewWayPoints;
//         var filtered = addNewWayPoints.filter(e => e != idx);
//         if(addNewWayPoints.length == 0)
//         {
//             globalWayPointCount = 0;
//         }
//         else{
//             addNewWayPoints = []
//             globalWayPointCount = 0
//             filtered.map((e, idx)=>{
//                 addNewWayPoints.push(idx+1)
//                 globalWayPointCount = globalWayPointCount+1
//             })
//         }
//         this.setState({
//             addNewWayPoints: addNewWayPoints
//         })
//     }

//     render(){
//         const dStyles={
//             width:'100%',
//             height:'600px',
//         }
//         const modalStyles  = {
// 			width:'500px !important',
// 		}
//         const columnDefs = [
//             {
//                 headerName: "",
//                 field: "checkbox",
//                 width: 50,
//                 checkboxSelection: true
//             },
//             {
//                 headerName: "",
//                 field: "add_way_points",
//                 cellRenderer: (params) => {
//                     return '<i class="fa fa-map-marker f25"></i> '
//                 },
//                 width: 50
//             },
//             {
//                 headerName: "",
//                 field: "_id",
//                 cellRenderer: (params) => {
//                     return '<i class="icofont icofont-map-pins f25"></i> '
//                 },
//                 width: 60
//             },
//             {
//                 headerName: "Source",
//                 field: "consigner_code",
//                 width: 120,
//                 valueGetter: (params)=>{
//                     return map_plants[params.data.consigner_code]
//                 }
//             },
//             {
//                 headerName: "Destination",
//                 field: "consignee_city",
//                 width: 120
//             },
//             {
//                 headerName: "Hero SAP Distance (Km)",
//                 field: "expected_distance",
//                 width: 120
//             },
//         ]
//         return (
            
//     		<div className="container-fluid">
//                 <SweetAlert
//                     show={this.state.show}
//                     type={this.state.basicType}
//                     title={this.state.basicTitle}
//                     onConfirm={this.closeAlert}
//                 >
//                 </SweetAlert>
// 	            {this.state.alert}
//             	<div className="row">
//             		<div className="col-xl-12 col-lg-12">
//                         <div className="row col-xl-12 col-lg-12">
//                             <div className="form-group col-xl-2 col-lg-2">
//                                 <label>Origin: </label>
//                                 <Select 
//                                     name="originoption"
//                                     closeMenuOnSelect={true} 
//                                     value={this.state.originoption} 
//                                     className="border-radius-0" 
//                                     onChange={this.changeOriginHandler.bind(this)} 
//                                     style={{borderRadius:"0px"}} 
//                                     options={this.state.originoptions} required
//                                 />
//                             </div>
//                             <div className="form-group col-xl-2 col-lg-2">
//                                 <label>Destination: </label>
//                                 <Select 
//                                     name="destinationoption"
//                                     closeMenuOnSelect={true} 
//                                     value={this.state.destinationoption} 
//                                     className="border-radius-0" 
//                                     onChange={this.changeDestinationHandler.bind(this)} 
//                                     style={{borderRadius:"0px"}} 
//                                     options={this.state.destinationOptions} required
//                                 />
//                             </div>
//                             <div className="form-group col-xl-2 col-lg-2">
//                                 <button style={{marginTop:"30px"}} onClick={this.formHandler.bind(this)} type="button" className="btn btn-success">Submit</button>
//                             </div>
                            
//                         </div>
// 		            	<div className="card">
// 			                <div className="card-header">
// 				       			<h5 style={{float: "left", width: "50%"}}>
// 				       				<i className="icofont icofont-map-pins f25"></i> <span>Hero SAP Routes</span>
// 				       			</h5>
// 				   			</div>
                            
// 				   			<div className="card-body row">
//                                 <div className="col-xl-4 col-lg-4">
//                                     <button className="btn btn-success" onClick={this.onClickAddWaypoints.bind(this)}>Add Waypoints</button>

//                                 </div>
//                                <div className="col-xl-8 col-lg-8">
//                                     <span style={{"float": "right"}}><i class="fa fa-minus fa-2x" style={{ color: "#157254" }}></i> <b style={{ "paddingRight": "10px"}}>Hero SAP Route </b></span>
//                                     <span style={{"float": "right"}}><i class="fa fa-minus fa-2x" style={{ color: "#452a68"}}></i> <b style={{ "paddingRight": "10px"}}>Missed GPS Route </b></span>
//                                     <button className="btn btn-warning" onClick={this.onClickSaveRoute.bind(this)}>Save Route</button>
//                                 </div>
//                                 <div className="row col-xl-12 col-lg-12 col-md-12 col-sm-12">
//                                     <div className="col-xl-4 col-lg-4">
//                                         <div id="myGrid" style={{ height: "600px",width: "100%"}}  className="ag-theme-balham">
//                                             <AgGridReact
//                                             modules={this.state.modules}
//                                             // onCellDoubleClicked={this.onShowSidebarAquireComponent.bind(this)}
//                                             columnDefs={columnDefs}
//                                             defaultColDef={this.state.defaultColDef}
//                                             rowData={this.state.rowData}
//                                             enableCharts={false}
//                                             enableRangeSelection={true}
//                                             autoGroupColumnDef={this.state.autoGroupColumnDef}
//                                             frameworkComponents={this.state.frameworkComponents}
//                                             onGridReady={this.onGridReady}
//                                             onGridState={this.onGridState}
//                                             statusBar={this.state.statusBar}
//                                             //sideBar={this.state.sideBar}
//                                             pagination={true}
//                                             onCellClicked={this.onCellClicked.bind(this)}
//                                             onRowSelected={this.onRowSelected.bind(this)}
//                                             />
//                                         </div>
//                                     </div>
// 								    <div className="col-xl-8 col-lg-8" id="map" style={dStyles}></div>
//                                 </div>
//                                 {/* <div className="col-xl-12 col-lg-12">
//                                     <div className="crm-numbers pb-0">
//                                         <h3 className="subH">{"Details"}</h3>
//                                         <div className="col-xl-12 col-lg-12 row">
//                                             <div className="col route-block">
//                                                 <label className="sidebar-label">Hero SAP Route Distance(Km)</label>
//                                                 <div>{this.state.expected_distance}</div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div> */}
//                             </div>
// 				   		</div>	
// 				   	</div>
// 				 </div>
//                 <div className={"dataLoadpage " +(this.state.loadshow)}>
//                 </div>
//                 <div className={"dataLoadpageimg " +(this.state.loadshow)}>
//                     <div class="loader-box"><div class="loader-box"><div class="rotate dashed colored"></div></div></div>
//                 </div>
//                 <div className={"overlay-part "+(this.state.overly)} onClick={this.onClickHideAll.bind(this)}></div>
//                 <Modal open={this.state.waypointsmodal} onClose={this.onCloseWaypointsModal.bind(this)} classNames={{
//                     modal: 'customModal2',
//                     }}>
// 					<div className={"row wayPointsDiv"} style={{padding:'5px 0px', zIndex:'9999',}} >
// 						<h5 className="model-title">Select Waypoints</h5>
// 						<form className="row col-xl-12 col-lg-12 mt-20p wayPointsBody" onSubmit={this.onSubmitWayPoints.bind(this)}>
// 							<div className='form-group col-xl-12 col-lg-12'>
//                                 <label>Source</label>
//                                 {(this.state.existing_route)?
//                                     <input className="form-control" value={map_plants[this.state.selectedRow.consigner_code]} style={{height:"37px"}} disabled/>
//                                 :
//                                     <Select 
//                                         name="originoption"
//                                         closeMenuOnSelect={true} 
//                                         value={this.state.originoption} 
//                                         className="border-radius-0" 
//                                         onChange={this.changeOriginHandler.bind(this)} 
//                                         style={{borderRadius:"0px"}} 
//                                         options={this.state.originoptions} required
//                                     />
//                                 }
                                
//                             </div>
                            
//                             {(this.state.addNewWayPoints.map((e, idx)=>{
//                                 return <div className='form-group col-xl-12 col-lg-12'>
//                                     <label className='col-xl-12 col-lg-12'>Way Point {e} <i className='fa fa-trash' style={{color: 'red', float: "right", cursor: "pointer"}} onClick={this.onClickRemoveWayPoint.bind(this,e)}></i></label>
//                                     <input type="text" name="search" onChange={this.onFocusSearch.bind(this, e)} className="form-control" style={{height:"37px"}} id={"way_point_search_"+(e)} placeholder="Enter Address to search" autoComplete='new-password' required/>
//                                 </div>
//                             }))}
//                             <div className='col-xl-12 col-lg-12 addNewWayPointLink'>
//                                 <a href="#0" onClick={this.onClickAddNewWayPoint.bind(this)} style={{float: "right"}}><i className='fa fa-plus'></i> Add New Waypoint</a>
//                             </div>
                            
//                             <div className='form-group col-xl-12 col-lg-12'>
//                                 <label>Destination</label>
//                                 {(this.state.existing_route)?
//                                     <input className="form-control" value={this.state.selectedRow.consignee_city} style={{height:"37px"}} disabled/>
//                                 :
//                                     <input type="text" name="search" onChange={this.onDestinationSearch} className="form-control" style={{height:"37px"}} id={"way_point_destination_search"} placeholder="Enter Destination to search" autoComplete='new-password' required/>

//                                     // <Select 
//                                     //     name="destinationoption"
//                                     //     closeMenuOnSelect={true} 
//                                     //     value={this.state.destinationoption} 
//                                     //     className="border-radius-0" 
//                                     //     onChange={this.changeDestinationHandler.bind(this)} 
//                                     //     style={{borderRadius:"0px"}} 
//                                     //     options={this.state.destinationOptions} required
//                                     // />
//                                 }
//                             </div>
//                             {(this.state.addNewWayPoints.length > 0)?
//                                 <div className="col-xl-12 col-lg-12" style={{textAlign: "center"}}>
//                                     <button className='btn btn-success'>Submit</button>
//                                 </div>
//                             :""}
                            
// 						</form>
// 					</div>
// 				</Modal>

//             </div>
              
//         );
//     }
// }

// function loadScript(url){
//     var index  =window.document.getElementsByTagName("script")[0]
//     var script = window.document.createElement("script")
//     script.src=url
//     script.async=true
//     script.defer = true
//     index.parentNode.insertBefore(script,index)
// }


// $(".wayPointsBody .form-group").on("input", "#way_point_"+globalWayPointCount, function(){
//     // console.log(this, "check")
//     var input = this;
//     var searchBox = new window.google.maps.places.SearchBox(input);
//     searchBox.addListener('places_changed', function() 
//     {
//         var places = searchBox.getPlaces();
        
//         if (places.length == 0) {
//         return;
//         }
//         var bounds = new window.google.maps.LatLngBounds();
//         places.forEach(function(place) {
//         if (!place.geometry) {
//             // console.log("Returned place contains no geometry");
//             return;
//         }
        

//         if (place.geometry.viewport) {
//             // Only geocodes have viewport.
//             bounds.union(place.geometry.viewport);
//         } else {
//             bounds.extend(place.geometry.location);
//         }
//         });
//     });
// })


// $(document).on("click", "i#delete_waypoint_"+globalWayPointCount,function(){
//     $(this).remove();
//     globalWayPointCount = globalWayPointCount - 1
// })

// function onWayPointchanged(){
//     // console.log("check")
// }